import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { 
  Row, 
  Col, 
  Modal, 
  Button, 
  Container, 
  Form, 
  Spinner,
  Card,
  ListGroup,
  Offcanvas,
  Overlay,
  OverlayTrigger,
  Tooltip,
  Popover,
  Table
} from 'react-bootstrap';

import { getAllCountries, getCountryByCode } from 'utilities/helpers'; // adjust path

import {
  closeBtn,
  informationIcon,
  signalIcon,
  signalSettingOne,
  signalSettingThree,
  signalSettingFour,
  signalSettingFive,
  signalSettingSix,
  signalSettingButton,
} from './../../assets/images';

import {
  variables,
  helpers,
  types,
  api,
} from 'utilities';

import { ColDef, ICellRendererParams } from 'ag-grid-community';

import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'; 
ModuleRegistry.registerModules([AllCommunityModule]);
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component


import { MultiSelect } from 'react-multi-select-component';
import { BiCopy } from 'react-icons/bi';
import { toast } from 'react-toastify';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSms } from '@fortawesome/pro-regular-svg-icons';

import { DEFAULT_API_RESULT } from 'utilities/variables';

import { useConfig } from 'utilities/variables/configContext';

import { faTrash, faCircleCheck  } from '@fortawesome/pro-regular-svg-icons';

/**
 * User Delete Modal
 *  - Renders Modal to allow users to delete any chosen profile
 * @param props 
 * @returns 
 */
export const UserDeleteModal: React.FunctionComponent<any> = (props: any) => {

  const { handleClose, show, handleModalFormSubmit, name } = props;

  const handleConfirmDelete = (event: any) => {
    event.preventDefault();

    handleModalFormSubmit();
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} centered contentClassName="k-mc-right" dialogClassName="kuro-modal" tabIndex={-1} className="k-modal k-m-right" >
        <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg'>
          <Row className='mt-1 k-panel-cent-vert'>
            <Col className='col-10'>
              <Modal.Title as="h5" className='p-1'>Confirm User Deletion</Modal.Title>
            </Col>
            <Col className='col-2 k-center-content-hor-right'>
              <button className='custom-close-button k-pointer' onClick={handleClose} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
                <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
              </button>
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body className='pt-2 pb-2'>
          <Row className='mt-2 m-2'>
            <Col className='col-9 p-0'>
              <span>Do you really want to delete <span className='txt-bold'>{name || 'this user'}</span>? This process cannot be undone.</span>
            </Col>
            <Col className='k-center-content p-0'>
              <Button variant="primary" onClick={handleConfirmDelete} className="p-1">
                Confirm
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}

/**
 * Group Delete Modal
 *  - Renders Modal to allow users to delete any chosen profile
 * @param props 
 * @returns 
 */
export const GroupDeleteModal: React.FunctionComponent<any> = (props: any) => {

  const { handleClose, show, handleModalFormSubmit, name } = props;

  const handleConfirmDelete = (event: any) => {
    event.preventDefault();

    handleModalFormSubmit();
  }


  return (
    <>
      <Modal show={show} onHide={handleClose} centered contentClassName="k-mc-right" dialogClassName="kuro-modal" tabIndex={-1} className="k-modal k-m-right" >
        <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg'>
          <Row className='mt-1 k-panel-cent-vert'>
            <Col className='col-10'>
              <Modal.Title as="h5" className='p-1'>Confirm Group Deletion</Modal.Title>
            </Col>
            <Col className='col-2 k-center-content-hor-right'>
              <button className='custom-close-button k-pointer' onClick={handleClose} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
                <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
              </button>
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body className='pt-2 pb-2'>
          <Row className='mt-2 m-2'>
            <Col className='col-9 p-0'>
              <span>Do you really want to delete <span className='txt-bold'>{name || 'this group'}</span>? This process cannot be undone.</span>
            </Col>
            <Col className='k-center-content p-0'>
              <Button variant="primary" onClick={handleConfirmDelete} className="p-1">
                Confirm
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}

/**
 * User Add Modal
 *  - Renders Form to allow users to add new generic products
 * @param props 
 * @returns 
 */
export const UserAddModal: React.FunctionComponent<any> = (props: any) => {
  const [modalFormBody, setModalFormBody] = useState<any>({});
  const [_isPhoneValid, setPhoneValid] = useState(true);
  const [isPasswordValid, setPasswordValid] = useState(false);
  const [confirmPasswordValid, setConfirmPasswordValid] = useState(false);
  const [isDisplayNameValid, setDisplayNameValid] = useState(true);
  const [isNameFieldsValid, setNameFieldsValid] = useState(true);
  const [isRoleValid, setRoleValid] = useState(false);
  const [isAuthValid, setAuthValid] = useState(false);
  const [isIdentifierValid, setIdentifierValid] = useState(false);
  const [submitClicked, setSubmitClicked] = useState(false);
  

  const [_isFormValid, setFormValid] = useState(false);

  const { handleClose, show, handleModalFormSubmit, submitError } = props;

  
  useEffect(() => {
    setModalFormBody({ authMethod: 'EMAIL', mfa: 'mfaDisabled' });
    setNameFieldsValid(true);
    setDisplayNameValid(true);
    setIdentifierValid(false);
    setPasswordValid(true);
    setConfirmPasswordValid(true);
    setPhoneValid(true);
    setRoleValid(false);
  }, [show])

  const handleInputChange = (event: any) => {
    const { name, value } = event.target;
    const valueTrimmed = value.trim();
  
    if (variables.DEFAULT_FORM_NAME_FIELDS.includes(name)) {
      if (variables.DEFAULT_FORM_VALIDATION.USER.NAME.test(value) || value === '') {
        setNameFieldsValid(true);
      } else {
        setNameFieldsValid(false);
      }
    }
  
    if (name === 'identifier') {
      const authMethod = modalFormBody.authMethod;
    
      let isValid = false;
    
      if (authMethod === 'EMAIL') {
        // Email-only mode: must be a valid email
        isValid = variables.DEFAULT_FORM_VALIDATION.USER.EMAIL.test(valueTrimmed);
      } else {
        // Password mode: email formatted username is only supported at the moment
        const isEmail = variables.DEFAULT_FORM_VALIDATION.USER.EMAIL.test(valueTrimmed);
        //const isUsername = variables.DEFAULT_FORM_VALIDATION.USER.USERNAME.test(valueTrimmed);
        const isUsername = variables.DEFAULT_FORM_VALIDATION.USER.EMAIL.test(valueTrimmed);
        isValid = isEmail || isUsername;
      }
    
      setIdentifierValid(isValid);
    }
  
    if (name === 'displayName') {
      if (variables.DEFAULT_FORM_VALIDATION.USER.DISPLAY_NAME.test(value) || value === '') {
        setDisplayNameValid(true);
      } else {
        setDisplayNameValid(false);
      }
    }
  
    if (name === 'phone') {
      if (variables.DEFAULT_FORM_VALIDATION.USER.PHONE_NUMBER.test(value) || value === '') {
        setPhoneValid(true);
      } else {
        setPhoneValid(false);
      }
    }

    if (name === 'role') {
      if (value !== '') {
        setRoleValid(true);
      } else {
        setRoleValid(false);
      }
    }

    if (name === 'authMethod') {
      if (value !== '') {
        setAuthValid(true);
      } else {
        setAuthValid(false);
      }
    }
  
    if (modalFormBody.authMethod === 'PASSWORD_MFA') {
      if (name === 'password') {
        if (variables.DEFAULT_FORM_VALIDATION.USER.PASSWORD.test(value) || value === '') {
          setPasswordValid(true);
        } else {
          setPasswordValid(false);
        }
    
        if (value === modalFormBody.password) {
          setConfirmPasswordValid(true);
        } else {
          setConfirmPasswordValid(false);
        }
      }
    
      if (name === 'confirmPassword') {
        if (value === modalFormBody.password) {
          setConfirmPasswordValid(true);
        } else {
          setConfirmPasswordValid(false);
        }
      }
    
    } else {
      // If not using password auth, always mark password fields valid
      setPasswordValid(true);
      setConfirmPasswordValid(true);
    }
      
    setModalFormBody({
      ...modalFormBody,
      [name]: value,
    });
  
    if (isDisplayNameValid && isIdentifierValid && isRoleValid && isPasswordValid && confirmPasswordValid) {
      setFormValid(true);
    } else {
      setFormValid(false);
    }
  };
  

  const validateForm = () => {
    return
  }

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    validateForm(); // currently empty but retained for structure
  
    const isPasswordAuth = modalFormBody.authMethod === 'PASSWORD_MFA';
  
    const canSubmit =
      isDisplayNameValid &&
      isIdentifierValid &&
      isRoleValid &&
      (isPasswordAuth
        ? isPasswordValid && confirmPasswordValid
        : true);
  
    if (canSubmit) {
      setSubmitClicked(true);
  
      await handleModalFormSubmit({
        body: {
          name: {
            last: modalFormBody['lastName'] || '',
            first: modalFormBody['firstName'] || '',
            middle: modalFormBody['middleName'] || '',
          },
          display_name: modalFormBody['displayName'] || '',
          identifier: modalFormBody['identifier']?.toLowerCase() || '',
          phone: modalFormBody['phone'] || '',
          profile_photo: {
            avatar: 'default',
          },
          role: modalFormBody['role'] || '',
          auth_method: modalFormBody['authMethod'] || '',
          mfa: 'mfaEnabled',
          pword: isPasswordAuth ? modalFormBody['password'] || '' : '',
        },
      });
  
      setSubmitClicked(false);
    } else {
      helpers.logToOutput('FORM NOT VALID... Won\'t make it so 7');
    }
  };
  


  const renderPasswordPopover = (
    <Popover id="popover-basic">
      <Popover.Header as="h3" style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold', fontSize: '1.1rem' }}>
        Password Help
      </Popover.Header>
      <Popover.Body style={{ padding: '0.5rem', fontSize: '0.9rem' }}>
        <p style={{ marginBottom: '0.2rem' }}>Passwords must be at least <strong>12 characters</strong> and contain:</p>
        <ul style={{ listStyleType: 'disc', paddingLeft: '1.25rem', lineHeight: '1.5' }}>
          <li>1 <span style={{ color: '#dc3545' }}>uppercase character</span></li>
          <li>1 <span style={{ color: '#dc3545' }}>symbol</span> (e.g.. <span style={{ color: '#dc3545' }}>!, ?</span>)</li>
          <li>1 <span style={{ color: '#dc3545' }}>number</span></li>
        </ul>
      </Popover.Body>
    </Popover>
  );

  return (
    <>
      <Modal show={show} onHide={handleClose} centered contentClassName="k-mc-right" dialogClassName="kuro-modal" tabIndex={-1} className="k-modal k-m-right" >
        <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg'>
          <Row className='mt-1 k-panel-cent-vert'>
            <Col className='col-10'>
              <Modal.Title as="h5" className='p-1'>Add User</Modal.Title>
            </Col>
            <Col className='col-2 k-center-content-hor-right'>
              <button className='custom-close-button k-pointer' onClick={handleClose} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
                <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
              </button>
            </Col>
          </Row>
        </Modal.Header>
        
        <Modal.Body className="k-modalBody">
          <Form onSubmit={handleFormSubmit}>
            <Container className="pe-0">
              <Row className="m-0 mb-3">
                <Col className="col-12 ps-0">
                  <span className='txt-10 color-lightHeader'>Username</span>
                  <Form.Group className="p-0 " controlId="modalUserAddForm.Email">
                    <Form.Control className="p-0 k-inputText k-inputText15 k-bord-col-trans k-outline-none" type="text" placeholder="Username or Email" name='identifier'  onChange={handleInputChange}/>
                    <hr className='k-border-top-black mt-0 mb-1'></hr>
                    {isIdentifierValid ?  null: <small className='ps-0' style={{color: 'red'}}>Enter a valid Username or Email</small>}
                  </Form.Group>
                </Col>
              </Row>
              <Row className="m-0 mb-3">
                <Col className="col-6 ps-0">
                  <span className='txt-10 color-lightHeader'>Full Name</span>
                  <Form.Group className="p-0 " controlId="modalUserAddForm.Firstname">
                    <Form.Control className="p-0 k-inputText k-inputText15 k-bord-col-trans k-outline-none" type="text" placeholder="First Name" name='firstName'  onChange={handleInputChange}/>
                    <hr className='k-border-top-black mt-0 mb-1'></hr>
                  </Form.Group>
                </Col>
                <Col className="col-6 ps-0">
                  <span className='txt-10 color-lightHeader'>Display Name</span>
                  <Form.Group className="p-0 " controlId="modalUserAddForm.DisplayName">
                    <Form.Control className="p-0 k-inputText k-inputText15 k-bord-col-trans k-outline-none" type="text" placeholder="Display Name" name='displayName'  onChange={handleInputChange}/>
                    <hr className='k-border-top-black mt-0 mb-1'></hr>
                  </Form.Group>
                </Col>
              </Row>
              <Row className='m-0'>
                {isNameFieldsValid ?  null: <small className='ps-0' style={{color: 'red'}}>Enter a valid User Name(s), lowercase {'(1 - 25 Alphanumeric only)'}</small>}
                {isDisplayNameValid ?  null: <small className='ps-0' style={{color: 'red'}}>Enter a valid Display Name. {'(1 - 25 Alphanumeric only)'}</small>}
              </Row>

              <Row className="m-0">
                <Col className="col-6 ps-0">
                  <span className='txt-10 color-lightHeader'>Role</span>
                  <Form.Group className="p-0 k-bord-col-trans k-outline-none" controlId="modalUserAddForm.Role">
                    <Form.Select aria-label="Select a role" className="k-inputSelect k-inputText15-light k-bord-col-trans k-outline-none p-0" name='role' defaultValue="" onChange={handleInputChange} >
                      <option disabled value="" >Select Role</option>
                      <option value="user" >User</option>
                      <option value="administrator">Admin</option>
                    </Form.Select>
                    <hr className='k-border-top-black mt-0 mb-1'></hr>
                  </Form.Group>
                </Col>
                <Col className="col-6 p-0">
                  <span className='txt-10 color-lightHeader'>Authentication Type</span>
                  <Form.Group className="p-0 k-bord-col-trans k-outline-none" controlId="modalUserAddForm.AuthMethod">
                    <Form.Select aria-label="Select a role" className="k-inputSelect k-inputText15-light k-bord-col-trans k-outline-none p-0" name='authMethod' defaultValue="" onChange={handleInputChange} >
                      <option disabled value="" >Select Authentication</option>
                      <option value="EMAIL" >Email</option>
                      <option value="PASSWORD_MFA">Password / MFA</option>
                    </Form.Select>
                    <hr className='k-border-top-black mt-0 mb-1'></hr>
                  </Form.Group>
                </Col>
              </Row>
              <Row className='m-0'>
                {isRoleValid ? null : (
                  <small className="ps-0" style={{ color: 'red' }}>
                    Select User&#39;s Role
                  </small>
                )}
                {isAuthValid ? null : (
                  <small className="ps-0" style={{ color: 'red' }}>
                    Select Authentication Type
                  </small>
                )}
              </Row>

              <Row className={`auth-section k-max-w-100pc m-0 p-0 ${modalFormBody.authMethod === 'PASSWORD_MFA' ? 'expand' : ''}`}>
                <Row className="m-0 mb-3 mt-2 px-0">
                  <Col className="col-6 ps-0">
                    <div>
                      <span className='txt-10 color-lightHeader'>Password</span>
                      <OverlayTrigger placement="right" delay={{ show: 250, hide: 400 }} overlay={renderPasswordPopover}>
                        <img className='ms-1 k-mh-12 k-opac-50pc k-pointer' src={informationIcon}></img>
                      </OverlayTrigger>
                    </div>
                    <Form.Group className="p-0 " controlId="modalUserAddForm.Password">
                      <Form.Control className="p-0 k-inputText k-inputText15 k-bord-col-trans k-outline-none" type="password" placeholder="Password" name='password'  onChange={handleInputChange}/>
                      <hr className='k-border-top-black mt-0 mb-1'></hr>
                      {isPasswordValid ?  null: <small className='ps-0' style={{color: 'red'}}>Password not valid </small>}
                    </Form.Group>
                  </Col>
                  <Col className="col-6 ps-0">
                    <span className='txt-10 color-lightHeader'>Confim Password</span>
                    <Form.Group className="p-0 " controlId="modalUserAddForm.ConfirmPassword">
                      <Form.Control className="p-0 k-inputText k-inputText15 k-bord-col-trans k-outline-none" type="password" placeholder="Confirm Password" name='confirmPassword'  onChange={handleInputChange}/>
                      <hr className='k-border-top-black mt-0 mb-1'></hr>
                      {confirmPasswordValid ? null : <small className='ps-0' style={{ color: 'red' }}>Passwords do not match</small>}
                    </Form.Group>
                  </Col>
                </Row>
              </Row>


              

              <Row className="m-0">
                <Col className="col-12 p-0 k-center-content-hor-right">
                  <div className="pt-3 k-center-content-hor-right-end">
                    <Button variant="secondary " 
                      type="submit"
                      disabled={!isDisplayNameValid || !isRoleValid || !isIdentifierValid || !isPasswordValid || submitClicked}
                      size="sm" className="k-btn-submit-col txt-14 k-center-content-hor-right-cen k-h-30">
                      Make it so
                    </Button>
                  </div>
                </Col>
              </Row>

              <Row className='m-0'>
                {submitError? (<>
                  <small style={{color: 'red'}}>{submitError}</small>
                </>): null}
              </Row>

            </Container>
          </Form>
        </Modal.Body>

      </Modal>
    </>
  );
}

export const NumberAddModal: React.FunctionComponent<any> = (props: any) => {
  const [modalFormBody, setModalFormBody] = useState<any>({});

  const [isNumberValid, setNumberValid] = useState(false);
  const [submitClicked, setSubmitClicked] = useState(false);
  
  const [_isFormValid, setFormValid] = useState(false);

  const { handleClose, show, handleModalFormSubmit, submitError } = props;
  const countries = getAllCountries();

  

  
  useEffect(() => {
    setModalFormBody({  });
    setNumberValid(false);
  }, [show])

  const handleInputChange = (event: any) => {
    const { name, value } = event.target;  

    if (name === 'number') {
      if (variables.DEFAULT_FORM_VALIDATION.MOBILE.NUMBER.test(value) || value === '') {
        setNumberValid(true);
      } else {
        setNumberValid(false);
      }
    }
        
    setModalFormBody({
      ...modalFormBody,
      [name]: value,
    });
  
    if (isNumberValid) {
      setFormValid(true);
    } else {
      setFormValid(false);
    }
  };
  

  const validateForm = () => {
    return
  }

  const handleFormSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    validateForm(); // currently empty but retained for structure

    const canSubmit = isNumberValid;

    if (canSubmit) {
      setSubmitClicked(true);

      try {
        const response = await handleModalFormSubmit({
          body: {
            number: modalFormBody['number'] || '',
            country: getCountryByCode(modalFormBody['countryCode'])?.name || '',
            countryCode: modalFormBody['countryCode'] || '',
            provider: 'provider-005',
            provider_name: 'Kuro',
            type: 'virtual_long_number',
            status: modalFormBody['status'] || 'suspended',
            sms: modalFormBody['sms'] ? modalFormBody['sms'] === 'true' : true,
            voice: modalFormBody['voice'] ? modalFormBody['voice'] === 'true' : false,
          },
        });

        if (response?.status === variables.DEFAULT_API_RESULT.SUCCESS) {
          toast.success('Number updated successfully');
          setSubmitClicked(false);
          handleClose();
        } else {
          toast.warn('Number update failed, please try again');
          helpers.logToOutput('ADMIN: UPDATE: USER: Err: ', response?.errorMessage);
        }
      } catch (err) {
        toast.error('Unexpected error occurred while updating number');
        helpers.logToOutput('ADMIN: UPDATE: USER: Exception: ', err);
      } finally {
        setSubmitClicked(false);
      }
    } else {
      helpers.logToOutput('Number FORM NOT VALID... Won\'t make it so');
    }
  };

  
  return (
    <>
      <Modal show={show} onHide={handleClose} centered contentClassName="k-mc-right" dialogClassName="kuro-modal" tabIndex={-1} className="k-modal k-m-right" >
        <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg'>
          <Row className='mt-1 k-panel-cent-vert'>
            <Col className='col-10'>
              <Modal.Title as="h5" className='p-1'>Add Number</Modal.Title>
            </Col>
            <Col className='col-2 k-center-content-hor-right'>
              <button className='custom-close-button k-pointer' onClick={handleClose} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
                <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
              </button>
            </Col>
          </Row>
        </Modal.Header>
        
        <Modal.Body className="k-modalBody">
          <Form onSubmit={handleFormSubmit}>
            <Container className="pe-0">
              <Row className="m-0 mb-3">
                <Col className="col-12 ps-0">
                  <span className='txt-10 color-lightHeader'>Number</span>
                  <Form.Group className="p-0 " controlId="modalNumberAddForm.Number">
                    <Form.Control className="p-0 k-inputText k-inputText15 k-bord-col-trans k-outline-none" type="text" placeholder="447123456789" name='number'  onChange={handleInputChange}/>
                    <hr className='k-border-top-black mt-0 mb-1'></hr>
                    {isNumberValid ?  null: <small className='ps-0' style={{color: 'red'}}>Enter a valid number with international code</small>}
                  </Form.Group>
                </Col>
              </Row>

              <Row className="m-0 mb-3">
                <Col className="col-12 ps-0">
                  <span className='txt-10 color-lightHeader'>Status</span>
                  <Form.Group className="p-0 k-bord-col-trans k-outline-none" controlId="modalNumberAddForm.Status">
                    <Form.Select aria-label="Select Status" className="k-inputSelect k-inputText15-light k-bord-col-trans k-outline-none p-0" name='role' defaultValue="" onChange={handleInputChange} >
                      <option disabled value="" >Select Status</option>
                      <option value="available">Available</option>
                      <option value="suspended">Suspened</option>
                    </Form.Select>
                    <hr className='k-border-top-black mt-0 mb-1'></hr>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="m-0 mb-3">
                <Col className="col-6 ps-0">
                  <span className='txt-10 color-lightHeader'>Provider</span>
                  <Form.Group className="p-0 " controlId="modalNumberAddForm.Provider">
                    <Form.Control className="p-0 k-inputText k-inputText15 k-bord-col-trans k-outline-none" type="text" placeholder="Kuro" name='provider' disabled  onChange={handleInputChange}/>
                    <hr className='k-border-top-black mt-0 mb-1'></hr>
                  </Form.Group>
                </Col>
                <Col className="col-6 ps-0">
                  <span className='txt-10 color-lightHeader'>Country</span>
                  <Form.Group
                    className="p-0 k-bord-col-trans k-outline-none"
                    controlId="modalNumberAddForm.Status"
                  >
                    <Form.Select
                      aria-label="Select Country"
                      className="k-inputSelect k-inputText15-light k-bord-col-trans k-outline-none p-0"
                      name="countryCode"
                      defaultValue=""
                      onChange={handleInputChange}
                    >
                      <option disabled value="">Select Country</option>
                      {countries.map((c) => (
                        <option key={c.code} value={c.code}>
                          {c.name} ({c.dial_code})
                        </option>
                      ))}
                    </Form.Select>
                    <hr className="k-border-top-black mt-0 mb-1" />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="m-0">
                <Col className="col-6 ps-0">
                  <span className='txt-10 color-lightHeader'>Voice</span>
                  <Form.Group className="p-0 k-bord-col-trans k-outline-none" controlId="modalNumberAddForm.Voice">
                    <Form.Select aria-label="Select status" className="k-inputSelect k-inputText15-light k-bord-col-trans k-outline-none p-0" name='voice' defaultValue="false" onChange={handleInputChange} >
                      <option disabled value="" >Select Status</option>
                      <option value="true">Enabled</option>
                      <option value="false">Disabled</option>
                    </Form.Select>
                    <hr className='k-border-top-black mt-0 mb-1'></hr>
                  </Form.Group>
                </Col>
                <Col className="col-6 p-0 pe-2">
                  <span className='txt-10 color-lightHeader'>SMS</span>
                  <Form.Group className="p-0 k-bord-col-trans k-outline-none" controlId="modalUserAddForm.AuthMethod">
                    <Form.Select aria-label="Select status" className="k-inputSelect k-inputText15-light k-bord-col-trans k-outline-none p-0" name='sms' defaultValue="true" onChange={handleInputChange} >
                      <option disabled value="" >Select Status</option>
                      <option value="true" >Enabled</option>
                      <option value="false">Disabled</option>
                    </Form.Select>
                    <hr className='k-border-top-black mt-0 mb-1'></hr>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="m-0">
                <Col className="col-12 p-0 k-center-content-hor-right">
                  <div className="pt-3 k-center-content-hor-right-end">
                    <Button variant="secondary " 
                      type="submit"
                      disabled={!isNumberValid || submitClicked}
                      size="sm" className="k-btn-submit-col txt-14 k-center-content-hor-right-cen k-h-30">
                      Make it so
                    </Button>
                  </div>
                </Col>
              </Row>

              <Row className='m-0'>
                {submitError? (<>
                  <small style={{color: 'red'}}>{submitError}</small>
                </>): null}
              </Row>

            </Container>
          </Form>
        </Modal.Body>

      </Modal>
    </>
  );
}

/**
 * Group Add Modal
 *  - Renders Form to allow users to add new generic products
 * @param props 
 * @returns 
 */
export const GroupAddModal: React.FunctionComponent<any> = (props: any) => {
  const [modalFormBody, setModalFormBody] = useState<any>({});
  const [isGroupNameValid, setGroupNameValid] = useState(false);
  const [isGroupDescriptionValid, setGroupDescriptionValid] = useState(false);
  const [groupUsers, setGroupUsers] = useState<any>([]);
  const [submitClicked, setSubmitClicked] = useState(false);


  const [_isFormValid, setFormValid] = useState(false);

  const { handleClose, show, handleModalFormSubmit, submitError } = props;

  
  useEffect(() => {
    setModalFormBody({});
    setGroupNameValid(false);
    setGroupDescriptionValid(false);
    setGroupUsers([]);
  }, [show])

  const handleInputChange = (event: any) => {
    if(event.target.name === 'name') {
      // event.target.value = event.target.value.split(" ").join("");
      // event.target.value = event.target.value.replace(" ", "");
      if (variables.DEFAULT_FORM_VALIDATION.GROUP.NAME.test(event.target.value)) {
        setGroupNameValid(true);
      } else {
        setGroupNameValid(false);
      }
    }

    if(event.target.name === 'description') {
      // event.target.value = event.target.value.split(" ").join("");
      // event.target.value = event.target.value.replace(" ", "");
      if (variables.DEFAULT_FORM_VALIDATION.GROUP.DESCRIPTION.test(event.target.value)) {
        setGroupDescriptionValid(true);
      } else {
        setGroupDescriptionValid(false);
      }
    }


    setModalFormBody({
      ...modalFormBody,
      [event.target.name]: event.target.value,
    });


    if (isGroupNameValid && isGroupDescriptionValid ){
      setFormValid(true)
    } else {
      setFormValid(false)
    }
  }


  const validateForm = () => {
    return;
  }

  const handleFormSubmit = async(event: any) => {
    event.preventDefault();

    validateForm();

    if (isGroupNameValid && isGroupDescriptionValid){
      setSubmitClicked(true);
      await handleModalFormSubmit({body: {
        ...modalFormBody,
        users: [
          ...groupUsers
        ]
      }});
      handleClose();
      setSubmitClicked(false);

    } else {
      helpers.logToOutput('FORM NOT VALID... Won\'t make it so 8');
    }
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} centered contentClassName="k-mc-right" dialogClassName="kuro-modal" tabIndex={-1} className="k-modal k-m-right" >
        <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg'>
          <Row className='mt-1 k-panel-cent-vert'>
            <Col className='col-10'>
              <Modal.Title as="h5" className='p-1'>Add Group</Modal.Title>
            </Col>
            <Col className='col-2 k-center-content-hor-right'>
              <button className='custom-close-button k-pointer' onClick={handleClose} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
                <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
              </button>
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body className="k-modalBody">
          <Form onSubmit={handleFormSubmit}>
            <Container className="pe-0">
              <Row className="m-0 mb-3">
                <Col className="col-12 ps-0 pt-2">
                  <span className='txt-10 color-lightHeader'>Group Name</span>
                  <Form.Group className="p-0 " controlId="modalGroupAddForm.Name">
                    <Form.Control className="p-0 k-inputText k-inputText15 k-bord-col-trans k-outline-none" type="text" placeholder="Group Name" name='name'  onChange={handleInputChange}/>
                    <hr className='k-border-top-black mt-0 mb-1'></hr>
                  </Form.Group>
                  {isGroupNameValid ?  null: <small style={{color: 'red'}}>Enter a valid Group Name. {'(5 - 25 Alphanumeric only)'}</small>}
                </Col>
              </Row>
              <Row className="m-0 mb-3">
                <Col className="col-12 ps-0">
                  <span className='txt-10 color-lightHeader'>Group Description</span>
                  <Form.Group className="p-0 " controlId="modalGroupAddForm.Description">
                    <Form.Control className="p-0 k-inputText k-inputText15 k-bord-col-trans k-outline-none" type="text" placeholder="Group Description" name='description'  onChange={handleInputChange}/>
                    <hr className='k-border-top-black mt-0 mb-1'></hr>
                  </Form.Group>
                  {isGroupDescriptionValid ?  null : <small style={{color: 'red'}}>Enter a valid Group Description. {'(Alphabets, Numbers, space and charcaters[-., ()/] accepted)'}</small>}
                </Col>
              </Row>
              <Row>
                <Col className="col-12 p-0 pe-3 k-center-content-hor-right">
                  <div className="pt-3 k-center-content-hor-right-end">
                    <Button variant="secondary " 
                      type="submit"
                      disabled={!(isGroupNameValid && isGroupDescriptionValid) || submitClicked}
                      size="sm" className="k-btn-submit-col txt-14 k-center-content-hor-right-cen k-h-30">
                      Make it so
                    </Button>
                  </div>
                </Col>
              </Row>
              <Row>
                {submitError? 
                  (<>
                    <small style={{color: 'red'}}>{submitError}</small>
                  </>): null
                }
              </Row>
            </Container>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export const LicenseAddModal: React.FunctionComponent<any> = (props: any) => {
  const [modalFormBody, setModalFormBody] = useState<any>({});
  const [isGroupNameValid, setGroupNameValid] = useState(false);
  const [isGroupDescriptionValid, setGroupDescriptionValid] = useState(false);
  const [groupUsers, setGroupUsers] = useState<any>([]);
  const [submitClicked, setSubmitClicked] = useState(false);


  const [_isFormValid, setFormValid] = useState(false);

  const { handleClose, show, handleModalFormSubmit, submitError } = props;

  
  useEffect(() => {
    setModalFormBody({});
    setGroupNameValid(false);
    setGroupDescriptionValid(false);
    setGroupUsers([]);
  }, [show])

  const handleInputChange = (event: any) => {
    if(event.target.name === 'name') {
      // event.target.value = event.target.value.split(" ").join("");
      // event.target.value = event.target.value.replace(" ", "");
      if (variables.DEFAULT_FORM_VALIDATION.GROUP.NAME.test(event.target.value)) {
        setGroupNameValid(true);
      } else {
        setGroupNameValid(false);
      }
    }

    if(event.target.name === 'description') {
      // event.target.value = event.target.value.split(" ").join("");
      // event.target.value = event.target.value.replace(" ", "");
      if (variables.DEFAULT_FORM_VALIDATION.GROUP.DESCRIPTION.test(event.target.value)) {
        setGroupDescriptionValid(true);
      } else {
        setGroupDescriptionValid(false);
      }
    }


    setModalFormBody({
      ...modalFormBody,
      [event.target.name]: event.target.value,
    });


    if (isGroupNameValid && isGroupDescriptionValid ){
      setFormValid(true)
    } else {
      setFormValid(false)
    }
  }


  const validateForm = () => {
    return;
  }

  const handleFormSubmit = async(event: any) => {
    event.preventDefault();

    validateForm();

    if (isGroupNameValid && isGroupDescriptionValid){
      setSubmitClicked(true);
      await handleModalFormSubmit({body: {
        ...modalFormBody,
        users: [
          ...groupUsers
        ]
      }});
      handleClose();
      setSubmitClicked(false);

    } else {
      helpers.logToOutput('FORM NOT VALID... Won\'t make it so 8');
    }
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} centered contentClassName="k-mc-right" dialogClassName="kuro-modal" tabIndex={-1} className="k-modal k-m-right" >
        <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg'>
          <Row className='mt-1 k-panel-cent-vert'>
            <Col className='col-10'>
              <Modal.Title as="h5" className='p-1'>Add Group</Modal.Title>
            </Col>
            <Col className='col-2 k-center-content-hor-right'>
              <button className='custom-close-button k-pointer' onClick={handleClose} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
                <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
              </button>
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body className="k-modalBody">
          <Form onSubmit={handleFormSubmit}>
            <Container className="pe-0">
              <Row className="m-0 mb-3">
                <Col className="col-12 ps-0 pt-2">
                  <span className='txt-10 color-lightHeader'>Group Name</span>
                  <Form.Group className="p-0 " controlId="modalGroupAddForm.Name">
                    <Form.Control className="p-0 k-inputText k-inputText15 k-bord-col-trans k-outline-none" type="text" placeholder="Group Name" name='name'  onChange={handleInputChange}/>
                    <hr className='k-border-top-black mt-0 mb-1'></hr>
                  </Form.Group>
                  {isGroupNameValid ?  null: <small style={{color: 'red'}}>Enter a valid Group Name. {'(5 - 25 Alphanumeric only)'}</small>}
                </Col>
              </Row>
              <Row className="m-0 mb-3">
                <Col className="col-12 ps-0">
                  <span className='txt-10 color-lightHeader'>Group Description</span>
                  <Form.Group className="p-0 " controlId="modalGroupAddForm.Description">
                    <Form.Control className="p-0 k-inputText k-inputText15 k-bord-col-trans k-outline-none" type="text" placeholder="Group Description" name='description'  onChange={handleInputChange}/>
                    <hr className='k-border-top-black mt-0 mb-1'></hr>
                  </Form.Group>
                  {isGroupDescriptionValid ?  null : <small style={{color: 'red'}}>Enter a valid Group Description. {'(Alphabets, Numbers, space and charcaters[-., ()/] accepted)'}</small>}
                </Col>
              </Row>
              <Row>
                <Col className="col-12 p-0 pe-3 k-center-content-hor-right">
                  <div className="pt-3 k-center-content-hor-right-end">
                    <Button variant="secondary " 
                      type="submit"
                      disabled={!(isGroupNameValid && isGroupDescriptionValid) || submitClicked}
                      size="sm" className="k-btn-submit-col txt-14 k-center-content-hor-right-cen k-h-30">
                      Make it so
                    </Button>
                  </div>
                </Col>
              </Row>
              <Row>
                {submitError? 
                  (<>
                    <small style={{color: 'red'}}>{submitError}</small>
                  </>): null
                }
              </Row>
            </Container>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export const licenseDeleteModal: React.FunctionComponent<any> = (props: any) => {

  const { show, handleClose, handleModalFormSubmit, name } = props;

  const handleConfirmDelete = (event: any) => {
    event.preventDefault();

    handleModalFormSubmit();
    handleClose();
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} centered contentClassName="k-mc-right" dialogClassName="kuro-modal" tabIndex={-1} className="k-modal k-m-right" >
        <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg'>
          <Row className='mt-1 k-panel-cent-vert'>
            <Col className='col-10'>
              <Modal.Title as="h5" className='p-1'>Confirm License Deletion</Modal.Title>
            </Col>
            <Col className='col-2 k-center-content-hor-right'>
              <button className='custom-close-button k-pointer' onClick={handleClose} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
                <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
              </button>
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body className='pt-2 pb-2'>
          <Row className='mt-2 m-2'>
            <Col className='col-9 p-0'>
              <span>Do you really want to delete <span className='txt-bold'>{name || 'this license'}</span>?</span>
            </Col>
            <Col className='k-center-content p-0'>
              <Button variant="primary" onClick={handleConfirmDelete} className="p-1">
                Confirm
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}

export const GenericPromptModal: React.FC<types.IGenericPromptModal> = ({ content, isVisible, handleModalHide }) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if(isVisible){
      // Simulate an async operation unitil we put proper feedback in from API
      setTimeout(() => {
        setIsLoading(false);
      }, 3000); // Adjust the delay as needed for your use case
    }
  }, [isVisible])


  return (
    <Modal show={isVisible} onHide={handleModalHide} centered className='k-z-ind-9999'>
      <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg'>
        <Row className='mt-1 k-panel-cent-vert'>
          <Col className='col-10'>
            <Modal.Title as="h5" className='p-1'>{content.title}</Modal.Title>
          </Col>
          <Col className='col-2 k-center-content-hor-right'>
            <button className='custom-close-button k-pointer' onClick={handleModalHide} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
              <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
            </button>
          </Col>
        </Row>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col className='col-12'>
            <Row className='pt-2'>
              <Col className='k-center-content'>
                {isLoading ? (
                  <div className='k-mh-25 k-center-content-hor-right k-center-content'>
                    <Spinner animation="border" role="status" >
                      <span className="visually-hidden">{content.loadingMessage}</span>
                    </Spinner>
                  </div>
                ) : (
                  <div  className='k-center-content-hor-right k-center-content'>
                    <span className="visually-hidden">{content.loadedMessage}</span>
                  </div>
                )}
              </Col>
            </Row>
            {/*<Row className='pt-2'><Col className='col-12'><span className='txt-14 pt-2'>You can now close this window</span></Col></Row>*/}
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

const LinkDeleteModal: React.FunctionComponent<any> = (props: any) => {

  const { show, handleClose, handleModalFormSubmit, name, id } = props;

  const handleConfirmDelete = (event: any) => {
    event.preventDefault();

    handleModalFormSubmit(id, name);
    handleClose();
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} centered content ClassName="k-mc-right k-z-ind-99999" dialogClassName="kuro-modal" tabIndex={-1} className="k-modal k-m-right" >
        <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg'>
          <Row className='mt-1 k-panel-cent-vert'>
            <Col className='col-10'>
              <Modal.Title as="h5" className='p-1'>Confirm Link Deletion</Modal.Title>
            </Col>
            <Col className='col-2 k-center-content-hor-right'>
              <button className='custom-close-button k-pointer' onClick={handleClose} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
                <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
              </button>
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body className='pt-2 pb-2'>
          <Row className='mt-2 m-2'>
            <Col className='col-9 p-0'>
              <span>Do you really want to delete <span className='txt-bold'>{name || 'this link'}</span>?</span>
            </Col>
            <Col className='k-center-content p-0'>
              <Button variant="primary" onClick={handleConfirmDelete} className="p-1">
                Confirm
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}

const CopyLinkModal: React.FunctionComponent<any> = (props: any) => {

  const { show, handleClose, handleModalFormSubmit, name, id } = props;

  const handleConfirmCopy = (event: any) => {
    event.preventDefault();

    handleModalFormSubmit(id, name);
    handleClose();
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} centered content ClassName="k-mc-right k-z-ind-99999" dialogClassName="kuro-modal" tabIndex={-1} className="k-modal k-m-right" >
        <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg'>
          <Row className='mt-1 k-panel-cent-vert'>
            <Col className='col-10'>
              <Modal.Title as="h5" className='p-1'>Copy Share Link</Modal.Title>
            </Col>
            <Col className='col-2 k-center-content-hor-right'>
              <button className='custom-close-button k-pointer' onClick={handleClose} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
                <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
              </button>
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body className='pt-2 pb-2'>
          <Row className='mt-2 m-2'>
            <Col className='col-9 p-0'>
              <span>The <span className='txt-bold'>{name || 'link'}</span> link is shown only once. Please copy and save it now, as you will not be able to view it again.</span>
            </Col>
            <Col className='k-center-content p-0'>
              <Button variant="primary" onClick={handleConfirmCopy} className="p-1">
                Copy
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}

const PasswordCellEditor: React.FC<{ value: string | null | undefined; onValueChange: (v: string | null) => void }> = ({
  value,
  onValueChange,
}) => (
  <input
    type="password"
    className="ag-input-field-input ag-text-field-input"
    value={value ?? ''}
    onChange={e => onValueChange(e.target.value === '' ? null : e.target.value)}
  />
);

export const CenterModalSharelink: React.FC<types.IModal> = ({ status, title, setShow, prodId, productTags }) => {
  const [shareLink, setShareShareLink] = useState<string>('');
  const [_linkCopied, setLinkCopied] = useState<boolean>(false);
  const [linkListDeleteObject, setLinkListDeleteObject] = useState<any>(null);
  const [isShowDeleteLinkModal, setDeleteLinkModalShow] = useState(false);
  const [isShowCopyLinkModal, setCopyLinkModalShow] = useState(false);
  const [linksLoading, setLinksLoading] = useState<boolean>(false);
  const [linksError, setLinksError] = useState<string | null>(null);
  const [creatingRowId, setCreatingRowId] = useState<string | null>(null);
  const [domains, setDomains] = useState<any[]>(['domains.com']);
  const { config } = useConfig();


  const canEdit = 'owner' === 'owner';
  //const domains = [ 'kuro.black', 'bobisgood.com', 'plumesofjoy.com', 'fantasticidentityranger.io'];

  const gridRef = useRef<AgGridReact<any>>(null);

  const [rowData, setRowData] = useState<any[]>([]);
  const hasPendingRow = useMemo(() => rowData.some(row => row?.isNew), [rowData]);

  const copyToClipboard = useCallback(() => {
    navigator.clipboard.writeText(shareLink);
    setLinkCopied(true);    
  }, [shareLink]);

  const deletePresignedLink = async (id: any) => {
    try {
      const query = {
        id: id
      };
  
      const result = await api.deletePresignedLink(query);
  
      if (result.status === DEFAULT_API_RESULT.SUCCESS) {
        helpers.logToOutput('Link deleted!');
        toast.success('Share link has been deleted');
        await loadProductPresignedLinks();
      } else {
        toast.error('Error deleting share link');
      }
    } catch (err) {
      toast.error('Error deleting share link');
      helpers.logToOutput('Error deleting link : ', err);
    }
  };

  const handleCloseDeleteLinkModal = (_event: any) => {
    // event.preventDefault();
    setDeleteLinkModalShow(false)
  };

  const handleCloseCopyLinkModal = (_event: any) => {
    // event.preventDefault();
    setCopyLinkModalShow(false)
  };

  const  handleLinkDelete = useCallback((licenseDeleteObjectItem: any) => {
    helpers.logToOutput('handleLinkDelete / handleLinkDelete : ')
    setLinkListDeleteObject(licenseDeleteObjectItem);
    setDeleteLinkModalShow(true);
  }, []);

  const handleAddNewRow = useCallback(() => {
    if (hasPendingRow) {
      toast.info('Please finish creating the current link first.');
      return;
    }

    const newRow = {
      id: `temp-${Date.now()}`,
      name: '',
      description: '',
      domain: domains[0] || '',
      nfb: '',
      expires_at: '',
      password: '',
      isNew: true,
    };

    setRowData(prev => [newRow, ...prev]);
  }, [domains, hasPendingRow]);

  const loadDomains = useCallback(async () => {

    try {
      if (config?.ADDITIONAL_DOMAINS) { 
        const domains: string[] = [config.DOMAIN_URL, ...(config.ADDITIONAL_DOMAINS ?? [])];
        setDomains(domains);
      } else {
        setDomains([config.DOMAIN_URL]);
      }
    } catch (error: any) {
      const message = error?.message ?? 'Unable to load share link domains';
      helpers.logToOutput('loadDomains Error:', message);
      setDomains([config.DOMAIN_URL]);
    }
  }, [config]);

  const loadProductPresignedLinks = useCallback(async () => {
    if (!prodId) {
      setRowData([]);
      return;
    }

    try {
      setLinksLoading(true);
      setLinksError(null);

      const response = await api.getProductPresignedLinks({ id: prodId });

      if (response?.status === DEFAULT_API_RESULT.SUCCESS) {
        const result = response.body?.result;
        const items = Array.isArray(result)
          ? result
          : Array.isArray((result as any)?.items)
            ? (result as any).items
            : [];

        const normalizedItems = items.map((item: any, index: number) => ({
          ...item,
          id: item.jti || item.id || item.link_id || item.name || `link-${index}`,
          // Make sure the fields your grid expects are present
          name: item.name ?? `Link ${index + 1}`,
          description: item.description ?? '',
          domain: item.domain ?? domains[0] ?? '',
          nfb: helpers.unixToDateString(item.nbf),
          expires_at: helpers.unixToDateString(item.expires_at),
          password: '*********', // we wont ever pass the password hash back
          isNew: false,
        }));

        setRowData(normalizedItems);
      } else {
        const message = response?.errorMessage ?? 'Unable to load share links';
        setLinksError(typeof message === 'string' ? message : 'Unable to load share links');
        setRowData([]);
      }
    } catch (error: any) {
      const message = error?.message ?? 'Unable to load share links';
      setLinksError(message);
      helpers.logToOutput('loadProductPresignedLinks Error:', message);
      setRowData([]);
    } finally {
      setLinksLoading(false);
    }
  }, [prodId, domains]);

  useEffect(() => {
    if (status) {
      loadProductPresignedLinks();
    }
  }, [status, loadProductPresignedLinks]);

  useEffect(() => {
    if (!status) return;
    loadDomains();
  }, [status, loadDomains]);

  const getShareLink = useCallback(async (linkObject: any) => {
    if (!linkObject?.isNew) {
      return;
    }

    if (!prodId) {
      toast.error('Missing product id');
      return;
    }

    const requiredFields = ['name', 'domain', 'nfb', 'expires_at'];
    const missing = requiredFields.filter(field => !linkObject[field]);
    if (missing.length) {
      toast.error(`Please fill ${missing.join(', ')} before creating the link.`);
      return;
    }

    setCreatingRowId(linkObject.id);

    

    try {
      const query = {
        id: prodId,
        body: {
          name: linkObject.name,
          description: linkObject.description,
          domain: linkObject.domain,
          nfb: helpers.toUnixFromStartOfDay(linkObject.nfb, 0),
          expires_at: helpers.toUnixFromStartOfDay(linkObject.expires_at, 86399),
          password: linkObject.password,
        },
      };


      const getPresignedLinkRes =await api.getpresignedLink(query);
      if (getPresignedLinkRes.status == DEFAULT_API_RESULT.SUCCESS){
        if (getPresignedLinkRes.body.result === 'successful') {
          toast.success('Share link created!');
          setShareShareLink(getPresignedLinkRes.body.url)
          setCopyLinkModalShow(true)
        } else {
          toast.error('Unable to create share link, please try again');
        }
      }
      
      await loadProductPresignedLinks();
    } catch (error: any) {
      helpers.logToOutput('getShareLink Error:', error?.message || error);
      toast.error('Unable to create share link');
    } finally {
      setCreatingRowId(null);
    }
  }, [prodId, loadProductPresignedLinks]);

  const components = useMemo(
    () => ({
      passwordCellEditor: PasswordCellEditor,
    }),
    []
  );

  const columnDefs = useMemo<ColDef<any>[]>(() => [
    { headerName: 'Link Name', field: 'name', minWidth: 5, editable: params => !!params.data?.isNew && canEdit, sortable: true, resizable: true, filter: true, width: 160},
    { headerName: 'Link Description', 
      field: 'description',
      editable: params => !!params.data?.isNew && canEdit,
      sortable: true,
      resizable: true,
      filter: true,
      flex: 1,
    },
    {
      headerName: 'Domain',
      field: 'domain',
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: {
        values: domains,
      },
      editable: params => !!params.data?.isNew && canEdit,
      width: 120
    },
    { headerName: 'Valid From', field: 'nfb', cellEditor: 'agDateStringCellEditor', cellDataType: 'dateString', minWidth: 5, editable: params => !!params.data?.isNew && canEdit, sortable: true, resizable: true, filter: false, width: 120},
    { headerName: 'Valid To', field: 'expires_at', cellEditor: 'agDateStringCellEditor', cellDataType: 'dateString', minWidth: 5, editable: params => !!params.data?.isNew && canEdit, sortable: true, resizable: true, filter: false, width: 120},
    {
      headerName: 'Password',
      field: 'password',
      valueFormatter: p => (p.value ? '********' : ''),
      cellEditor: 'passwordCellEditor',
      editable: params => !!params.data?.isNew && canEdit,
      sortable: false,
      resizable: true,
      filter: false,
      width: 115,
    },
    {
      headerName: '',
      field: 'actions',
      cellRenderer: (params: ICellRendererParams) => {
        const isNewRow = !!params.data?.isNew;
        const isSaving = creatingRowId === params.data?.id;

        return (
          <div className="d-flex justify-content-center align-items-center h-100">
            {isNewRow ? (
              isSaving ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <FontAwesomeIcon
                  className={'color-RS k-pointer'}
                  onClick={() => getShareLink(params.data)}
                  icon={faCircleCheck}
                />
              )
            ) : (
              <>
                <FontAwesomeIcon
                  className="color-MA k-pointer ms-2"
                  onClick={() => handleLinkDelete(params.data)}
                  icon={faTrash}
                />
              </>
            )}
          </div>
        );
      },
      width: 60,
      editable: false,
      sortable: true,
      resizable: false
    }
  ], [canEdit, creatingRowId, domains, getShareLink, handleLinkDelete]);

  return (
    <>
      <LinkDeleteModal
        show={isShowDeleteLinkModal}
        handleClose={handleCloseDeleteLinkModal}
        handleModalFormSubmit={deletePresignedLink}
        name={linkListDeleteObject?.name ?? ''}
        id={linkListDeleteObject?.id ?? ''}
      />
      <CopyLinkModal
        show={isShowCopyLinkModal}
        handleClose={handleCloseCopyLinkModal}
        handleModalFormSubmit={copyToClipboard}
        name={linkListDeleteObject?.name ?? ''}
        id={linkListDeleteObject?.id ?? ''}
      />
      <Modal show={status} onHide={() => setShow(false)} centered className='' dialogClassName="k-modal-w-70-pc">
        <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg'>
          <Row className='mt-1 k-panel-cent-vert'>
            <Col className='col-10'>
              <Modal.Title as="h5" className='p-1'>{title}</Modal.Title>
            </Col>
            <Col className='col-2 k-center-content-hor-right'>
              <button className='custom-close-button k-pointer' onClick={() => setShow(false)} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
                <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
              </button>
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className='col-auto py-2'>
              <div
                className={'k-no-select k-center-content txt-18 txt-bold color-RS k-bg-btn b-rad-5 k-h-40 k-w-40'}
              >
                {/* Render the content for the handle*/}
                {(() => {
                  const kshortKey = Object.keys(productTags).find(key => key.startsWith('kshortTitle'));
                  return kshortKey ? productTags[kshortKey] : 'XX';
                })()}
              </div>
            </Col>
            <Col className='col py-2 ps-0'>
              <Row className="d-flex align-items-start" ><Col><span className='txt-14 txt-weight-600 p-0 m-0 d-flex align-items-start'>{productTags.kname}</span></Col></Row>
              <Row className="d-flex align-items-start" ><Col><span className='txt-11 p-0 m-0 d-flex align-items-start'>Click on the new link button to generate a new share link</span></Col></Row>
            </Col>
            <Col className='col-3 py-2 ps-0 d-flex justify-content-end align-items-center'>
              <div className='d-flex'>
                <Button
                  className='color-RS k-bg-btn k-border-none'
                  size="sm"
                  onClick={handleAddNewRow}
                  variant="primary"
                  disabled={linksLoading || hasPendingRow || !!creatingRowId}
                >
                  New Link
                </Button>
              </div>
            </Col>
          </Row>
          <Row>
            {linksLoading ? (
              <div className="d-flex align-items-center justify-content-center" style={{ height: 200 }}>
                <Spinner animation="border" size="sm" role="status" className='me-2' />
                <span>Loading presigned links...</span>
              </div>
            ) : linksError ? (
              <div className="d-flex flex-column align-items-center justify-content-center txt-13 color-MA" style={{ height: 200 }}>
                {linksError}
              </div>
            ) : (
              <div className="ag-theme-quartz" style={{ width: '100%', height: 200 }}>
                <AgGridReact<any>
                  ref={gridRef}
                  rowData={rowData}
                  columnDefs={columnDefs}
                  rowSelection="single"
                  animateRows={true}
                  components={components}
                />
              </div>
            )}
          </Row>
        </Modal.Body>
      </Modal>
      
    </>
  );
}

export const CenterModalMessages: React.FC<types.IModal> = ({ status, title, setShow, prodId, prodName }) => {
  const [messagesStatus, setMessagesStatus] = useState<boolean>(false);
  const [messages, setMessages] = useState<types.ProductMessage[] | null>([]);
  const [selectedMessage, setSelectedMessage] = useState<types.ProductMessage | null>(null);

  const getMessages = async (productId: string) => {
    setMessagesStatus(false);
    const query = {
      id: productId,
      body: {
        key: '',
      },
    };
  
    api.getProductMessages(query)
      .then((result) => {
        try {
          const responseObj = typeof result.body.responseObj === 'string'
            ? JSON.parse(result.body.responseObj)
            : result.body.responseObj;
  
          //helpers.logToOutput('getMessages Modal MATCH (Parsed):', responseObj);
  
          const sortedMessages = (responseObj.items || []).sort(
            (a: types.ProductMessage, b: types.ProductMessage) => {
              const dateA = new Date(a.received_at || 0).getTime();
              const dateB = new Date(b.received_at || 0).getTime();
              return dateB - dateA;
            }
          );
  
          setMessages(sortedMessages); // Set the sorted array of messages
          setSelectedMessage(sortedMessages[0] || null); // Default to the first (newest) message
          setMessagesStatus(true);
        } catch (error) {
          helpers.logToOutput('JSON Parsing Error:', error);
          setMessagesStatus(true);
        }
      })
      .catch((_error) => {
        //helpers.logToOutput('getMessages Error:', error);
        setMessagesStatus(true);
      });
  };

  useEffect(() => {
    helpers.logToOutput('CenterModalMessages Status:', status);
    if (status === true) {
      getMessages(prodId);
    }
  }, [status, prodId]);

  return (
    <Modal show={status} onHide={() => setShow(false)} centered dialogClassName='k-message-modal' className='k-z-ind-9999'>
      <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg'>
        <Row className='mt-1 k-panel-cent-vert'>
          <Col className='col-10'>
            <Modal.Title as="h5" className='p-1'>{title} for {prodName}</Modal.Title>
          </Col>
          <Col className='col-2 k-center-content-hor-right'>
            <button className='custom-close-button k-pointer' onClick={() => setShow(false)} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
              <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
            </button>
          </Col>
        </Row>
      </Modal.Header>
      <Modal.Body>
        <Row className='m-0 ps-2 ps-0'>
          <Col className='col-4 pt-4 ps-0'>
            {messagesStatus ? (
              messages && messages.length > 0 ? (
                <>
                  <Table className='k-brd-transparent'>
                    <div className="k-overflow-y-scroll" style={{ height: '400px' }}>
                      <tbody className='k-t-body-scroll-admin k-disp-inline-tbl k-wh-100pc'>
                        {messages.map((message) => (
                          <tr className='k-bord-col-trans' key={`prod-messages-${message?.message_id}`}>
                            <td className='pt-1 pb-1' onClick={() => setSelectedMessage(message)}>
                              <div key={message.message_id} className={selectedMessage?.message_id === message.message_id ? 'k-bg-selected-light b-rad-5 p-2' : 'k-hover p-2 b-rad-5 k-wh-100pc'}>
                                <Row>
                                  <Col className='col-2 pe-0'>
                                    <FontAwesomeIcon size="xl" icon={faSms} fixedWidth />
                                  </Col>
                                  <Col className='col-10'>
                                    <Row><Col className='col-12'>{message.sender ?? 'None'}</Col></Row>
                                    <Row>
                                      <Col className="col-12 txt-12 color-lightText">
                                        {new Date(message.received_at).toLocaleString('en-GB', { timeZone: 'UTC' })}
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </div>
                  </Table>
                </>
              ) : (
                <p>No messages available.</p>
              )
            ) : (
              <p>Loading messages...</p>
            )}
          </Col>
          <Col className="col-8 p-0">
            <Row className="m-0 mt-2">
              <Col className="col-12 pt-3">
                {selectedMessage ? (
                  <>
                    <div className="k-overflow-y-scroll" style={{ height: '400px' }}>
                      <div className='k-t-body-scroll-admin k-disp-inline-tbl k-wh-100pc'>
                        <Card className='k-b-shadow-none ps-0 growable-div k-overflow-a pt-1 mb-0'>
                          <Card.Header className='ps-3'>
                            <Row>
                              <Col className='col-8'>
                                <Row>
                                  <Col className='col-12'>
                                    <h4 className='mt-0 mb-0'>{selectedMessage.sender}</h4>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col className='col-12 txt-12 color-lightText'>
                                    Sent: {new Date(selectedMessage.received_at).toLocaleString('en-GB', { timeZone: 'UTC' })}
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Card.Header>
                          <Card.Body className='p-0 pt-4'>
                            <Row>
                              <Col md={12}>
                                <Card>
                                  <Card.Header className='p-2 ps-3 txt-14' ><strong>Message Details</strong></Card.Header>
                                  <ListGroup variant="flush txt-12">
                                    <ListGroup.Item>
                                      <Row>
                                        <Col className='col-3'><strong>Sender:</strong></Col>
                                        <Col className='col-9'>{(selectedMessage.sender ?? 'None')}</Col>
                                      </Row>
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                      <Row>
                                        <Col className='col-3'><strong>Recipient:</strong> </Col>
                                        <Col className='col-9'>{selectedMessage.destination ?? 'None'} </Col>
                                      </Row>
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                      <Row>
                                        <Col className='col-3'><strong>Received At</strong></Col>
                                        <Col className='col-9'>{new Date(selectedMessage.received_at).toLocaleString('en-GB', { timeZone: 'UTC' })}</Col>
                                      </Row>
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                      <Row>
                                        <Col className='col-3'><strong>Delivered:</strong> </Col>
                                        <Col className='col-9'>{selectedMessage.delivered ? 'Yes' : 'No'}</Col>
                                      </Row>
                                    </ListGroup.Item>
                                  </ListGroup>
                                </Card>
                              </Col>
                            </Row>

                            <Row className="mt-3">
                              <Col md={12}>
                                <Card>
                                  <Card.Header className='p-2 ps-3 txt-14'><strong>Message Content</strong></Card.Header>
                                  <Row className='ps-3'>
                                    <Col className='p-2 ps-3'>
                                      {selectedMessage.clean_text}
                                    </Col>
                                  </Row>
                                </Card>
                              </Col>
                            </Row>
                          </Card.Body>
                        </Card>
                      </div>
                    </div>
                  </>
                ) : (
                  <p>Select a message to view details</p>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export const CenterModalShowPassword: React.FC<types.IModal> = ({ status, title, setShow, prodId }) => {
  const [credentialStatus, setCredentialsStatus] = useState<boolean>(false);
  const [credentialAdmin, setCredentialAdmin] = useState<string>('');
  const [credentialStandard, setCredentialUser] = useState<string>('');
  const [_passwordMessage, setPasswordMessage] = useState<string>('');
  const [_credsCopied, setCredsCopied] = useState<boolean>(false);
  const [isAdminPasswordVisible, setIsAdminPasswordVisible] = useState(false);
  const [isStandardPasswordVisible, setIsStandardPasswordVisible] = useState(false);
  const [isAdminHovered, setIsAdminHovered] = useState(false);
  const [isStandardHovered, setIsStandardHovered] = useState(false);

  const [showAdmin, setShowClickedAdmin] = useState(false);
  const [showStandard, setShowClickedStandard] = useState(false);
  const targetAdmin = useRef(null);
  const targetStandard = useRef(null);

  const toggleAdminPasswordVisibility = () => {
    setIsAdminPasswordVisible(!isAdminPasswordVisible);
  };

  const toggleStandardPasswordVisibility = () => {
    setIsStandardPasswordVisible(!isStandardPasswordVisible);
  };

  const getCredentials = useCallback(() => {
    setCredentialsStatus(false);

    const query = {
      id: prodId,
      body: {
        key: ''
      }
    };

    api.getProductCredentials(query)
      .then(result => {
        setPasswordMessage('Passwords retrieved');
        setCredentialAdmin(result.body.responseObj.admin);
        setCredentialUser(result.body.responseObj.standard);
        setCredentialsStatus(true);
      })
      .catch(_error => {
        setPasswordMessage('Oh ... something went wrong!');
        setCredentialsStatus(true);
      });
  }, [prodId]);

  const hideTooltipAfterTimeout = (setShowTooltip: React.Dispatch<React.SetStateAction<boolean>>) => {
    setShowTooltip(true);
    setTimeout(() => {
      setShowTooltip(false);
    }, 750);
  };

  const copyStandardToClipboard = () => {
    navigator.clipboard.writeText(credentialStandard);
    setCredsCopied(true);
    hideTooltipAfterTimeout(setShowClickedStandard);
  };

  const copyAdminToClipboard = () => {
    navigator.clipboard.writeText(credentialAdmin);
    setCredsCopied(true);
    hideTooltipAfterTimeout(setShowClickedAdmin);
  };

  useEffect(() => {
    if (status === true) {
      setCredsCopied(false);
      getCredentials();
    }
  }, [status, getCredentials]);

  return (
    <Modal show={status} onHide={() => setShow(false)} centered className="k-z-ind-9999">
      <Modal.Header className="p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg">
        <Row className="mt-1 k-panel-cent-vert">
          <Col className="col-10">
            <Modal.Title as="h5" className="p-1">
              {title}
            </Modal.Title>
          </Col>
          <Col className="col-2 k-center-content-hor-right">
            <button
              className="custom-close-button k-pointer"
              onClick={() => setShow(false)}
              style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
            >
              <img className="k-mh-20 k-opac-50pc k-pointer k-mb-02r" src={closeBtn} alt="close" />
            </button>
          </Col>
        </Row>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <span className="txt-12 pt-2">To reveal the password, click on the dots that conceal the password. To copy the password, click on the copy button.</span>
        </Row>
        <Row>
          <p className="mb-0 mt-2">
            <>
              {!credentialStatus ? (
                <Spinner animation="border" variant="secondary" />
              ) : (
                <>
                  <Row onMouseEnter={() => setIsAdminHovered(true)} onMouseLeave={() => setIsAdminHovered(false)}>
                    <Col className="col-10">
                      <Row>
                        <Col className='k-mb-m-20'>
                          <span className="k-clip-text txt-10 pt-2">
                            Admin Password
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <span className="k-clip-text txt-14 pt-2 color-RS" onClick={toggleAdminPasswordVisibility} style={{ cursor: 'pointer' }}>
                            {isAdminPasswordVisible ? credentialAdmin : '•'.repeat(credentialAdmin.length)}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                    <Col className="col-2">

                      {isAdminHovered && (
                        <button
                          className="k-click mt-3"
                          ref={targetAdmin}
                          onClick={copyAdminToClipboard}
                          style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
                        >
                          <BiCopy />
                        </button>
                      )}
                      <Overlay target={targetAdmin.current} show={showAdmin} placement="right">
                        {(props) => (
                          <Tooltip className="k-z-ind-99999 k-clicked-tooltip" id="overlay-example" {...props}>
                            Copied!
                          </Tooltip>
                        )}
                      </Overlay>
                    </Col>
                  </Row>
                  <Row onMouseEnter={() => setIsStandardHovered(true)} onMouseLeave={() => setIsStandardHovered(false)}>
                    <Col className="col-10">
                      <Row>
                        <Col className='k-mb-m-20'>
                          <span className="k-clip-text txt-10 pt-2">
                            User Password
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <span className="k-clip-text txt-14 pt-2 color-RS" onClick={toggleStandardPasswordVisibility} style={{ cursor: 'pointer' }}>
                            {isStandardPasswordVisible ? credentialStandard : '•'.repeat(credentialStandard.length)}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                    <Col className="col-2">
                      {isStandardHovered && (
                        <button
                          ref={targetStandard}
                          className="k-click mt-3"
                          onClick={copyStandardToClipboard}
                          style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
                        >
                          <BiCopy />
                        </button>
                      )}
                      <Overlay target={targetStandard.current} show={showStandard} placement="right">
                        {(props) => (
                          <Tooltip className="k-z-ind-99999 k-clicked-tooltip" id="overlay-example" {...props}>
                            Copied!
                          </Tooltip>
                        )}
                      </Overlay>
                    </Col>
                  </Row>
                </>
              )}
            </>
          </p>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export const CenterModalShowRename: React.FC<types.IModal> = ({ status, title, setShow, prodId }) => {
  const [deviceName, setDeviceName] = useState<string>('');
  const [isRenaming, setIsRenaming] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const handleClose = useCallback(() => {
    setShow(false);
    setDeviceName('');
    setErrorMessage('');
    setIsRenaming(false);
  }, [setShow]);

  const handleRename = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!deviceName.trim()) {
      setErrorMessage('Please enter a device name.');
      return;
    }

    if (!prodId) {
      setErrorMessage('Missing product id.');
      return;
    }

    setIsRenaming(true);
    setErrorMessage('');

    try {
      const payload = {
        id: prodId,
        body: {
          key: 'tags.kname',
          value: deviceName.trim(),
        },
      };

      const response = await api.putProductUpdateName(payload);

      if (response?.status === variables.DEFAULT_API_RESULT.SUCCESS) {
        toast.success('Device name updated');
        handleClose();
      } else {
        setErrorMessage('Unable to rename device right now.');
        toast.warn('Unable to rename device right now.');
      }
    } catch (_error) {
      setErrorMessage('Unable to rename device right now.');
      toast.error('Unable to rename device right now.');
      helpers.logToOutput('RENAME DEVICE: Exception: ', _error);
    } finally {
      setIsRenaming(false);
    }
  };

  useEffect(() => {
    if (status) {
      setDeviceName('');
      setErrorMessage('');
      setIsRenaming(false);
    }
  }, [status]);

  return (
    <Modal show={status} onHide={handleClose} centered className="k-z-ind-9999">
      <Modal.Header className="p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg">
        <Row className="mt-1 k-panel-cent-vert">
          <Col className="col-10">
            <Modal.Title as="h5" className="p-1">
              {title}
            </Modal.Title>
          </Col>
          <Col className="col-2 k-center-content-hor-right">
            <button
              className="custom-close-button k-pointer"
              onClick={handleClose}
              style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
            >
              <img className="k-mh-20 k-opac-50pc k-pointer k-mb-02r" src={closeBtn} alt="close" />
            </button>
          </Col>
        </Row>
      </Modal.Header>
      <Modal.Body className="pt-3 pb-3">
        <Form onSubmit={handleRename}>
          <Row>
            <Col className="col-10">
              <Row>
                <Col className=''>
                  <span className="k-clip-text txt-12 ps-1">
                    Change the name of your device below
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="align-items-center">
            <Col className="col-9">
              <Form.Control
                className="k-inputText k-inputText15 k-outline-none border rounded-2"
                type="text"
                placeholder="Enter new device name"
                value={deviceName}
                onChange={(event) => setDeviceName(event.target.value)}
                disabled={isRenaming}
                autoFocus
              />
            </Col>
            <Col className="col-3 d-flex justify-content-end">
              <Button
                type="submit"
                className="k-min-w-103 p-2"
                variant="outline-dark"
                disabled={isRenaming || !prodId}
              >
                {isRenaming ? 'updating...' : 'update'}
              </Button>
            </Col>
          </Row>
          {errorMessage && (
            <Row className="mt-2">
              <Col>
                <span className="k-clip-text txt-12 ps-1 text-danger">{errorMessage}</span>
              </Col>
            </Row>
          )}
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export const CenterModalChangeOwner: React.FC<types.IModal> = ({ status, title, setShow, prodId }) => {
  const [selectedUser, setSelectedUser] = useState<{ label: string; value: string } | null>(null);
  const [options, setOptions] = useState<{ label: string; value: string }[]>([]);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isUpdatingOwner, setIsUpdatingOwner] = useState<boolean>(false);

  const handleClose = useCallback(() => {
    setShow(false);
    setSelectedUser(null);
    setOptions([]);
    setErrorMessage('');
    setIsUpdatingOwner(false);
  }, [setShow]);

  const valueRenderer = (selected: typeof options) => {
    if (!selected.length) {
      return <></>;
    }

    return <span className="k-bg-selected m-1 p-1 b-rad-5">{selected[0].label}</span>;
  };

  const getUsers = useCallback(async () => {
    try {
      const usersResponse = await api.getUsers({});

      if (usersResponse?.status === variables.DEFAULT_API_RESULT.SUCCESS) {
        const userOptions = usersResponse.body.map((user: types.IUserListAttributes) => ({
          label: user.display_name,
          value: user.id,
        }));

        setOptions(userOptions);
      } else {
        setErrorMessage('Unable to load users right now.');
        helpers.logToOutput('CHANGE OWNER: getUsers error', usersResponse?.errorMessage);
      }
    } catch (_error) {
      setErrorMessage('Unable to load users right now.');
      helpers.logToOutput('CHANGE OWNER: getUsers exception', _error);
    }
  }, []);

  const handleUpdateOwner = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!selectedUser) {
      setErrorMessage('Please select a user.');
      return;
    }

    if (!prodId) {
      setErrorMessage('Missing product id.');
      return;
    }

    setIsUpdatingOwner(true);
    setErrorMessage('');

    try {
      const payload = {
        id: prodId,
        body: {
          key: 'user',
          value: selectedUser.value,
        },
      };

      const response = await api.putProductUpdateName(payload);

      if (response?.status === variables.DEFAULT_API_RESULT.SUCCESS) {
        toast.success('Owner updated');
        handleClose();
      } else {
        setErrorMessage('Unable to update owner right now.');
        toast.warn('Unable to update owner right now.');
      }
    } catch (_error) {
      setErrorMessage('Unable to update owner right now.');
      toast.error('Unable to update owner right now.');
      helpers.logToOutput('CHANGE OWNER: Exception: ', _error);
    } finally {
      setIsUpdatingOwner(false);
    }
  };

  useEffect(() => {
    if (status) {
      setSelectedUser(null);
      setOptions([]);
      setErrorMessage('');
      setIsUpdatingOwner(false);
      getUsers();
    }
  }, [status, getUsers]);

  return (
    <Modal show={status} onHide={handleClose} centered className="k-z-ind-9999">
      <Modal.Header className="p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg">
        <Row className="mt-1 k-panel-cent-vert">
          <Col className="col-10">
            <Modal.Title as="h5" className="p-1">
              {title}
            </Modal.Title>
          </Col>
          <Col className="col-2 k-center-content-hor-right">
            <button
              className="custom-close-button k-pointer"
              onClick={handleClose}
              style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
            >
              <img className="k-mh-20 k-opac-50pc k-pointer k-mb-02r" src={closeBtn} alt="close" />
            </button>
          </Col>
        </Row>
      </Modal.Header>
      <Modal.Body className="pt-3 pb-3">
        <Form onSubmit={handleUpdateOwner}>
          <Row>
            <Col className="col-10">
              <Row>
                <Col className=''>
                  <span className="k-clip-text txt-12 ps-1">
                    Select the new owner for this device below
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="align-items-center">
            <Col className="col-9">
              <MultiSelect
                options={options}
                value={selectedUser ? [selectedUser] : []}
                onChange={(selected: any[]) => setSelectedUser(selected[0] ?? null)}
                valueRenderer={valueRenderer}
                hasSelectAll={false}
                labelledBy="Select"
                disableSearch={true}
              />
            </Col>
            <Col className="col-3 d-flex justify-content-end">
              <Button
                type="submit"
                className="k-min-w-103 p-2"
                variant="outline-dark"
                disabled={isUpdatingOwner || !prodId}
              >
                {isUpdatingOwner ? 'updating...' : 'update'}
              </Button>
            </Col>
          </Row>
          {errorMessage && (
            <Row className="mt-2">
              <Col>
                <span className="k-clip-text txt-12 ps-1 text-danger">{errorMessage}</span>
              </Col>
            </Row>
          )}
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export const CenterModalSetScreenSize: React.FC<types.IModal> = ({ status, title, setShow, prodId }) => {
  const [sizeStatus, setSizeStatus] = useState<boolean>(false);
  const [screenSizes, setScreenSizes] = useState<{ label: string; value: string }[]>([]);
  const [selectedSize, setSelectedSize] = useState<{ label: string; value: string } | null>(null); // State for single selected size
  const [_message, setMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [_hasSetScreenSize, setHasSetScreenSize] = useState<boolean>(false);

  const [_screenStatus, setScreenStatus] = useState<boolean>(false);
  const [_screenSizeResponse, setScreenSizeResponse] = useState<string>('');
  const [_isLoadingSet, setLoadingSet] = useState(false);

  const [isScreenSizesFetched, setIsScreenSizesFetched] = useState<boolean>(false); // New state to track when screen sizes are fetched

  const getScreenSizes = useCallback(() => {
    setSizeStatus(false);
  
    const query = {
      id: prodId,
      body: {
        metatype: 'screensize',
        metasubtype: 'desktop',
      },
    };
  
    api.getMetadata(query)
      .then((result) => {
        setMessage('Screen sizes retrieved');
        const options = result.body.responseObj.Value
          .map((size: string) => ({
            label: size,
            value: size,
          }))
          .sort((a: any, b: any) => a.label.localeCompare(b.label));
        setScreenSizes(options);
        setSizeStatus(true);
        setIsScreenSizesFetched(true);
      })
      .catch(() => {
        setMessage('Oh ... something went wrong, screen sizes not retrieved!');
        setSizeStatus(true);
        setIsScreenSizesFetched(false);
      });
  }, [prodId, setSizeStatus, setMessage, setScreenSizes, setIsScreenSizesFetched]);
  

  const getProductMeta = useCallback(() => {
    const query = {
      id: prodId,
      body: {
        key: 'screendimension',
      },
    };
  
    api.getProductMeta(query)
      .then((result) => {
        setMessage('Screen size retrieved');
  
        screenSizes.forEach((size) => {
          if (size.value === result.body.responseObj) {
            helpers.logToOutput('getProductMeta MATCH:', size.value);
          }
        });
  
        const matchedSize = screenSizes.find(
          (size) => size.value === result.body.responseObj
        );
  
        setSelectedSize(matchedSize || null);
      })
      .catch(() => {
        setMessage('Oh ... something went wrong, screen sizes not retrieved!');
      });
  }, [prodId, screenSizes, setMessage, setSelectedSize]);
  

  const setScreenSize = async (newScreenSize: string, productID: string) => {
    setScreenStatus(false);
    
    const putResponse = await api.putProductMeta({
      id: productID,
      body: {
        key: 'screendimension',
        value: newScreenSize,
      },
    });

    

    if (putResponse.status === 200) {
      setScreenStatus(true);
      setScreenSizeResponse('All good... your desktop screen size has been set');
      setLoadingSet(false);
      setHasSetScreenSize(true);
      setIsLoading(false)
      setShow(false)
      //update product state by asking the websocket to grab the product list
      //callback()
    } else {
      setScreenStatus(true);
      //callback()
      setScreenSizeResponse('Oh ... something went wrong!');
      setLoadingSet(false);
      setIsLoading(false)
    }
  };

  useEffect(() => {
    setHasSetScreenSize(false);
  }, []);

  useEffect(() => {
    if (status === true) {
      getScreenSizes();
    }
  }, [status, getScreenSizes]);

  useEffect(() => {
    if (isScreenSizesFetched) {
      getProductMeta(); // Run this when screen sizes have been fetched
    }
  }, [isScreenSizesFetched, getProductMeta]);

  const handleSizeChange = (selected: { label: string; value: string }[]) => {
    if (selected.length > 1) {
      // Prevent more than one selection
      setSelectedSize(selected[selected.length - 1]);
    } else {
      setSelectedSize(selected[0]);
    }
  };

  const handleClick = () => {
    setIsLoading(true);
    // Simulate an API call
    setScreenSize(selectedSize?.value || '', prodId);
  };

  const valueRenderer = (selected: { label: string; value: string }[]) => {
    if (selected.length === 0) {
      return 'Select a screen size';
    }
    return selected[0]?.label; // Show only the selected item
  };

  return (
    <Modal show={status} onHide={() => setShow(false)} centered className="k-z-ind-9999">
      <Modal.Header className="p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg">
        <Row className="mt-1 k-panel-cent-vert">
          <Col className="col-10">
            <Modal.Title as="h5" className="p-1">
              {title}
            </Modal.Title>
          </Col>
          <Col className="col-2 k-center-content-hor-right">
            <button
              className="custom-close-button k-pointer"
              onClick={() => setShow(false)}
              style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
            >
              <img className="k-mh-20 k-opac-50pc k-pointer k-mb-02r" src={closeBtn} alt="close" />
            </button>
          </Col>
        </Row>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <span className="txt-12 pt-2">Select a screen size from one of the options below, when set the selected size will be used for all future sessions.</span>
        </Row>
        <Row>
          <p className="mb-0 mt-2">
            <>
              {!sizeStatus ? (
                <Spinner animation="border" variant="secondary" />
              ) : (
                <>
                  <Row>
                    <Col className='col-9'>
                      <MultiSelect
                        options={screenSizes}
                        value={selectedSize ? [selectedSize] : []}
                        onChange={handleSizeChange}
                        valueRenderer={valueRenderer}
                        hasSelectAll={false}
                        labelledBy="Select"
                        disableSearch={true} // Disable search
                      />
                    </Col>
                    <Col className='col-3 d-flex justify-content-center align-items-center'>
                      <Button
                        className="k-min-w-103 p-2"
                        variant="outline-dark"
                        disabled={isLoading}
                        onClick={!isLoading ? handleClick : undefined}
                      >
                        {isLoading ? 'updating...' : 'update'}
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
            </>
          </p>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export const CenterModalShareUser: React.FC<types.IModal> = ({ status, title, setShow, prodId, prodShare, callback }) => {

  const [_getShareUserStatus, setGetShareUserStatus] = useState<boolean>(false);
  const [_setShareUserStatus, setSetShareUserStatus] = useState<boolean>(false);
  const [_shareUserResponse, setShareUserResponse] = useState<string>('');  

  const [selected, setSelected] = useState<Array<{ label: string, value: string }>>([]);
  const [oldSelected, setOldSelected] = useState<Array<{ label: string, value: string }>>([]);
  const [isLoading, setLoading] = useState(false);
  const [hasShared, setHasShared] = useState(false);
  const [userList, setUserList] = useState<types.IUserListAttributes[]>([]); 
  const [options, setOptions] = useState<{ label: string; value: string }[]>([]);

  const handleClose = useCallback(() => {
    setShow(false);
    setHasShared(false);
    // setSelected([]);
    // setOldSelected([]);
  }, [setShow, setHasShared]);

  const getUsers = async () => {

    setGetShareUserStatus(false);
    const getUsersResponse = await api.getUsers({});  

    if ( getUsersResponse.status === variables.DEFAULT_API_RESULT.SUCCESS){
      setUserList(getUsersResponse.body);
      return getUsersResponse.body;
    } else {
      /**
         * TO-DO:
         * - DO some error pop-up here for eg.
         */
      helpers.logToOutput('User Profile Attributes: Err: ', getUsersResponse.errorMessage);
      return {};
    }
  }

  const mapUserIdsToUsers = useCallback((userIds: string[], usersList: types.IUserListAttributes[]) => {

    return userIds?.map(userId => {
      const user = usersList.find(user => user.id === userId);
      if (user) {
        return {
          label: user.display_name,
          value: userId
        };
      }
      return null;
    }).filter(Boolean);
  }, []);
  
  const putShareProductUser = useCallback(
    async (userID: string, productID: string) => {
      setSetShareUserStatus(false);
  
      const response = await api.putShareProductUser({
        id: productID,
        body: { id: userID }
      });
  
      if (response.result === variables.DEFAULT_API_RESULT.SUCCESS) {
        setSetShareUserStatus(true);
        setShareUserResponse('All good... your desktop has been shared');
        setHasShared(true);
        callback();
        toast.success('User has been added!');
      } else {
        setSetShareUserStatus(true);
        callback();
        setShareUserResponse('Oh ... something went wrong!');
        toast.warn('Sorry, the user wasn\'t added — are you the owner?');
      }
    },
    [callback]
  );
  
  const delShareProductUser = useCallback(
    async (userID: string, productID: string) => {
      setSetShareUserStatus(false);
  
      const response = await api.delShareProductUser({
        id: productID,
        body: { id: userID }
      });
  
      if (response.result === variables.DEFAULT_API_RESULT.SUCCESS) {
        setSetShareUserStatus(true);
        setShareUserResponse('User has been removed from desktop sharing');
        setHasShared(true);
        callback();
        toast.success('User has been removed!');
      } else {
        setSetShareUserStatus(true);
        callback();
        setShareUserResponse('Oh ... something went wrong!');
        toast.warn('Sorry, the user wasn\'t removed — are you the owner?');
      }
    },
    [callback]
  );

  const valueRenderer = (selected: typeof options) => {

    if (!selected.length) {
      return <></>;
    }

    return selected.length === 1 ? (
      <span className='k-bg-selected m-1 p-1 b-rad-5'>{selected[0].label}</span>
    ) : (
      selected.map(({ label }) => <span className='k-bg-selected m-1 p-1 b-rad-5' key={label}>{label}</span>)
    );

    
  };

  const handleClick = async () => {
    setLoading(true);
    await updateSharedUsers();
    setLoading(false);
  };

  const updateSharedUsers = useCallback(async () => {
    const usersToAdd = selected.filter(
      user => !oldSelected.some(old => old.value === user.value)
    );
  
    const usersToRemove = oldSelected.filter(
      user => !selected.some(selectedUser => selectedUser.value === user.value)
    );
  
    if (usersToAdd.length > 0) {
      for (const user of usersToAdd) {
        await putShareProductUser(user.value, prodId);
      }
    }
  
    if (usersToRemove.length > 0) {
      for (const user of usersToRemove) {
        await delShareProductUser(user.value, prodId);
      }
    }
  
    setOldSelected(selected);
    handleClose();
  }, [selected, oldSelected, prodId, putShareProductUser, delShareProductUser, handleClose]);
  
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {

    if (status === true ) {
      setHasShared(false);
  
      const fetchData = async () => {
        const usersList = await getUsers();
  
        const mappedUsers = prodShare ? mapUserIdsToUsers(prodShare, usersList) : [];
  
        setSelected(prev => prev.length === 0 ? mappedUsers : prev);
        setOldSelected(mappedUsers);
      };
  
      fetchData();
    }
  }, [status]);
  /* eslint-enable react-hooks/exhaustive-deps */
  

  useEffect(() => {
    const userOptions = userList.map((user) => ({
      label: user.display_name,
      value: user.id,
    }));
  
    setOptions(userOptions);
  }, [userList]);


  return (
    <Modal show={status} onHide={() => setShow(false)} centered className='k-z-ind-9999' dialogClassName="k-min-w-600">
      <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-mh-35 k-menu-grey-two-bg'>
        <Row className='mt-1 k-panel-cent-vert'>
          <Col className='col-10'>
            <Modal.Title as="h5" className='p-1'>{title}</Modal.Title>
          </Col>
          <Col className='col-2 k-center-content-hor-right'>
            <button className='custom-close-button k-pointer' onClick={() => setShow(false)} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
              <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
            </button>
          </Col>
        </Row>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <span className='txt-12 pt-2'>Select the users from the dropdown box, and share your desktop!</span>
        </Row>
        <Row>
          <p className="mb-0 mt-2">
              
            <Row>
              <Col className='col-9'>
                <MultiSelect
                  options={options}
                  value={selected}
                  onChange={setSelected}
                  valueRenderer={valueRenderer}
                  hasSelectAll={false}
                  labelledBy="Select"
                />
              </Col>
              <Col className='col-3 d-flex justify-content-center align-items-center'>
                <Button className="k-min-w-103 p-2" variant="outline-dark" disabled={isLoading} onClick={!isLoading ? handleClick : undefined}>
                  {isLoading ? 'updating...' : 'update'}
                </Button>
              </Col>
            </Row>
            <Row>
              <span className='txt-12 pt-2'>{hasShared ? 'Updated!' : ' '}</span>
            </Row>

            {/*<Spinner animation="border" variant="secondary" />*/}
            
          </p>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export const CenterModalSignal: React.FC<types.IModal> = ({
  status, title, setShow, prodId
}) => {
  const [step, setStep] = useState<number>(0);
  const [confirmReady, setConfirmReady] = useState<boolean>(false); // set true when backend ready

  const viewportRef = useRef<HTMLDivElement | null>(null);
  const [slideWidth, setSlideWidth] = useState<number>(0);
  const [error, setError] = useState<string>(null);
  const [info, setInfo] = useState<string>(null);

  // Measure width once the Offcanvas is visible, and on window resize
  useEffect(() => {
    const measure = () => {
      const w = viewportRef.current?.clientWidth ?? 0;
      setSlideWidth(w);
    };

    if (status) {
      // measure now and after paint to catch transition/layout
      measure();
      const id = window.setTimeout(measure, 0);
      window.addEventListener('resize', measure);
      return () => {
        window.clearTimeout(id);
        window.removeEventListener('resize', measure);
      };
    }
  }, [status]);

  const steps = useMemo<{ id: number; content: React.ReactNode }[]>(
    () => [
      {
        id: 0,
        content: (
          <>
            <Row><Col className='mb-3'><p><strong>1. </strong> Open Signal on your device, and tap on the profile icon <img className="k-h-15" src={signalSettingButton}/> in the top left of the display.</p></Col></Row>
            <Row><Col className='d-flex justify-content-center'><img className="k-h-300" src={signalSettingOne} alt="Signal" /></Col></Row>
          </>
        ),
      },
      {
        id: 1,
        content: (
          <>
            <Row><Col className='mb-3'><p><strong>2. </strong> When the settings menu opens, click on the <strong>Linked Devices</strong> option</p></Col></Row>
            <Row><Col className='d-flex justify-content-center'><img className="k-h-300" src={signalSettingThree} alt="Signal" /></Col></Row>
          </>
        ),
      },
      {
        id: 2,
        content: (
          <>
            <Row><Col className='mb-3'><p><strong>3. </strong> When the linked devices menu opens, click on the <strong>Link new device</strong> option</p></Col></Row>
            <Row><Col className='d-flex justify-content-center'><img className="k-h-300" src={signalSettingFour} alt="Signal" /></Col></Row>
          </>
        ),
      },
      {
        id: 3,
        content: (
          <>
            <Row><Col className='mb-3'><p><strong>4. </strong> If requested tap the <strong>allow access</strong> button and proceed to the next step.</p></Col></Row>
            <Row><Col className='d-flex justify-content-center'><img className="k-h-300" src={signalSettingFive} alt="Signal" /></Col></Row>
          </>
        ),
      },
      {
        id: 4,
        content: (
          <>
            <Row><Col className='mb-3'><p><strong>5. </strong>Please wait a few moments until the QR code has been automatically recognised.</p></Col></Row>
            <Row><Col className='d-flex justify-content-center'><img className="k-h-300" src={signalSettingSix} alt="Signal" /></Col></Row>
          </>
        ),
      },
    ],
    []
  );

  const lastStep = steps.length - 1;

  const handleClose = useCallback(() => {
    // optional: notify cancel -> callback?.({ action: 'cancel' as const });
    setShow(false);
    setStep(0);
    setConfirmReady(false);
    setError(null);
    setInfo(null);
  }, [setShow]);

  const handleNext = useCallback(() => {
    setInfo(null);
    setError(null);
    setStep((s) => Math.min(s + 1, lastStep));
  }, [lastStep, setInfo, setError]);

  const handleBack = useCallback(() => {
    setInfo(null);
    setError(null);
    setStep((s) => Math.max(s - 1, 0));
  }, [setInfo, setError]);

  const finsihSignalSetup = async () => {
    try {
      const query = {
        id: prodId,
        body: { 
          id: prodId,
          host_id: prodId
        }
      };

      const result = await api.getSignalForwardingSetup(query);

      if (result.status === DEFAULT_API_RESULT.SUCCESS) {
        setShow(false);
      } else {
        setError('Signal could not process the request, reset and try again');
        setInfo(null);
      }
    } catch (err) {
      setError('Could not talk to signal please try again');
      setInfo(null);
    }
  };

  const handleConfirm = () => {
    finsihSignalSetup();
  };

  const resetSignalSetup = async () => {
    try {
      const query = {
        id: prodId,
        body: { 
          id: prodId,
          host_id: prodId
        }
      };

      const result = await api.deleteSignalForwardingSetup(query);

      if (result.status === DEFAULT_API_RESULT.SUCCESS) {
        setInfo('Signal service has been reset');
        setError(null);
      } else {
        setError('Signal could not process the request, reset and try again');
        setInfo(null);
      }
    } catch (err) {
      setError('Could not talk to signal please try again');
      setInfo(null);
    }
  };

  const handleReset = () => {
    resetSignalSetup();
  };

  // Styles kept minimal
  const trackStyle: React.CSSProperties = {
    display: 'flex',
    flexWrap: 'nowrap',
    transform: `translateX(-${step * slideWidth}px)`,
    transition: 'transform 300ms ease-in-out',
    willChange: 'transform',
  };

  const confirmDisabled = !(step === lastStep && confirmReady);

  useEffect(() => {
    if (!status) return; // only run when modal is opened
    const startSignalSetup = async () => {
      try {
        const query = {
          id: prodId,
          body: { 
            id: prodId,
            host_id: prodId
          }
        };

        const result = await api.postSignalForwardingSetup(query);

        if (result.status === DEFAULT_API_RESULT.SUCCESS) {
          setConfirmReady(true);
        } else {
          setConfirmReady(false);
        }
      } catch (err) {
        setConfirmReady(false);
      }
    };

    startSignalSetup();
  }, [status, prodId]);

  return (
    <Offcanvas className="k-z-ind-9999" show={status} onHide={handleClose} scroll={false} backdrop={false} placement="end">
      <Offcanvas.Header className='k-display-block'>
        <Row className="align-items-center">
          <Col className="col-2 d-flex justify-content-center">
            <img className="k-h-40" src={signalIcon} alt="Signal" />
          </Col>
          <Col className="col-10">
            <Offcanvas.Title>{title}</Offcanvas.Title>
          </Col>
        </Row>
      </Offcanvas.Header>

      <Offcanvas.Body className="d-flex flex-column">
        {/* Viewport that defines the slide width */}
        <div ref={viewportRef} style={{ overflow: 'hidden', width: '100%' }}>
          {/* Sliding row */}
          <Row className="g-0" style={trackStyle}>
            {steps.map((s) => (
              <Col className="k-panelStyle" key={s.id} xs={12}>
                {s.content}
              </Col>
            ))}
          </Row>
        </div>

        {/* Actions */}
       
        <div className="mt-auto">
          <div>
            {error && <span className='txt-12' style={{ color: 'red' }}>{error} </span>}
            {info && <span className='txt-12' style={{ color: 'blue' }}>{info} </span>}
          </div>
          <div className="k-actionsBar d-flex align-items-center justify-content-between gap-2">
            <Button className='k-h-30 py-0' variant="outline-warning" onClick={handleClose}>Cancel</Button>
            <Button className='k-h-30 py-0' variant="outline-danger" onClick={handleReset}>Reset</Button>

            <div className="d-flex gap-2">
              <Button className='k-h-30 py-0' variant="secondary" onClick={handleBack} disabled={step === 0}>Back</Button>
              {step < lastStep ? (
                <Button className='k-h-30 py-0' variant="primary" onClick={handleNext}>Next</Button>
              ) : (
                <Button className='k-h-30 py-0' variant="success" onClick={handleConfirm} disabled={confirmDisabled}>Confirm</Button>
              )}
            </div>
          </div>
          {/* Flip when backend ready: setConfirmReady(true) */}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export const CenterModalSecurePaste: React.FC<types.IModal> = ({ status, title, setShow, prodId }) => {
  const [isLoading, setLoading] = useState(false);
  const [_hasSent, setHasSent] = useState(false);
  const [_apiStatus, setApiStatus] = useState(false);
  const [url, setUrl] = useState(''); // State for URL input

  const handleClick = () => {
    if (url && helpers.isValidUrl(url)) {
      setLoading(true);
      putSendText(url, prodId);
    } else {
      toast.warn('Please enter a valid URL');
    }
  };

  const putSendText = async (text: string, productID: string) => {
    setApiStatus(false);
    const encodedText = btoa(text);
    const apiResponse = await api.putProductPaste({
      id: productID,
      body: {
        key: 'windowschrome',
        action: 'paste',
        value: encodedText
      }
    });
    if (apiResponse?.parameter_value.result === variables.DEFAULT_API_RESULT.SUCCESS) {
      setApiStatus(true);
      setLoading(false);
      setHasSent(true);
      setUrl(''); // Clear the input field
      setShow(false); // Close the modal
      toast.success('Your URL has been sent! Please wait a few moments and it will open in chrome on your desktop');
    } else {
      setApiStatus(true);
      setLoading(false);
      toast.warn(`Sorry that didn't work: ${apiResponse?.parameter_value.result}`);
    }
  };

  return (
    <Modal show={status} onHide={() => setShow(false)} centered className='k-z-ind-9999' dialogClassName="k-min-w-600">
      <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-mh-35 k-menu-grey-two-bg'>
        <Row className='mt-1 k-panel-cent-vert'>
          <Col className='col-10'>
            <Modal.Title as="h5" className='p-1'>{title}</Modal.Title>
          </Col>
          <Col className='col-2 k-center-content-hor-right'>
            <button className='custom-close-button k-pointer' onClick={() => setShow(false)} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
              <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn} alt="close" />
            </button>
          </Col>
        </Row>
      </Modal.Header>
      <Modal.Body>
        <Row className='pt-1'>
          <Col className='col-8'><span className='txt-12 pt-2'>Enter the URL you wish to send to the desktop</span></Col>
          <Col className='col-4 k-center-content-hor-right'>
            <OverlayTrigger
              trigger="click"
              key='top'
              placement='top'
              rootClose
              overlay={
                <Popover className="k-z-ind-999996" id="url-popover-positioned-top" style={{ maxWidth: '600px', fontSize: '0.65rem' }}>
                  <Popover.Header as="h3" className='ps-2'>URL Help</Popover.Header>
                  <Popover.Body className='ps-2 pt-2 pb-2 pe-2 k-w-500 '>
                    <Row className='p-0'>
                      <Col className='col-6'>
                        <strong className='mb-0 pb-2'>Accepted Formats - <span className='k-prod-start'> CORRECT</span></strong>
                        <ul className='ps-3 mb-0'>
                          <li>https://example.com</li>
                          <li>http://example.com/path?query=value</li>
                          <li>ftp://example.com</li>
                          <li>customprotocol://example.com/path</li>
                          <li>example.com</li>
                          <li>example.com/path/to/resource</li>
                          <li>/path/to/resource</li>
                          <li>subfolder/resource.txt</li>
                        </ul>
                      </Col>
                      <Col className='col-6'>
                        <strong className='mb-0 pb-2'>Rejected Formats  - <span className='k-prod-stop'> INCORRECT</span></strong>
                        <ul className='ps-3 mb-0'>
                          <li>://example.com (missing scheme)</li>
                          <li>http:/example.com (incomplete scheme)</li>
                          <li>/path with space/resource</li>
                          <li>example.com/path with space</li>
                          <li>http:// (no domain)</li>
                          <li>ftp:// (no domain)</li>
                          <li>&quot;&quot; (empty string or space only)</li>
                          <li>user@domain (email URL structure)</li>
                        </ul>
                      </Col>
                    </Row>
                  </Popover.Body>
                </Popover>
              }
            >
              <Button variant="link" className='p-0 txt-12 text-decoration-none'>What is a valid URL?</Button>
            </OverlayTrigger>
          </Col>
        </Row>
        <Row>
          <p className="mb-0 mt-2">
            <Row>
              <Col className='col-9'>
                <Form.Control
                  type="text"
                  placeholder="Enter URL"
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}  // Capture URL input
                  disabled={isLoading}
                />
              </Col>
              <Col className='col-3 d-flex justify-content-center align-items-center'>
                <Button className="k-min-w-103 p-2" variant="outline-dark" disabled={isLoading} onClick={!isLoading ? handleClick : undefined}>
                  {isLoading ? 'Sending...' : 'Send'}
                </Button>
              </Col>
            </Row>
          </p>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export const CenterModalShareGroup: React.FC<types.IModal> = ({ status, title, setShow, prodId, prodShare, callback }) => {

  const [_getShareGroupStatus, setGetShareGroupStatus] = useState<boolean>(false);
  const [_setShareGroupStatus, setSetShareGroupStatus] = useState<boolean>(false);
  const [_shareGroupResponse, setShareGroupResponse] = useState<string>('');  

  const [selected, setSelected] = useState<Array<{ label: string, value: string }>>([]);
  const [oldSelected, setOldSelected] = useState<Array<{ label: string, value: string }>>([]);
  const [isLoading, setLoading] = useState(false);
  const [hasShared, setHasShared] = useState(false);
  const [groupList, setGroupList] = useState<types.IGroupListAttributes[]>([]); 
  const [options, setOptions] = useState<{ label: string; value: string }[]>([]);


  const getGroups = async () => {

    setGetShareGroupStatus(false);
    const getGroupsResponse = await api.getGroups({});
    
    if ( getGroupsResponse.status === variables.DEFAULT_API_RESULT.SUCCESS){
      setGroupList(getGroupsResponse.body.groups);
      return getGroupsResponse.body.groups;
    } else {
      /**
         * TO-DO:
         * - DO some error pop-up here for eg.
         */
      helpers.logToOutput('Group Profile Attributes: Err: ', getGroupsResponse.errorMessage);
      return {};
    }
  }

  const mapGroupIdsToGroups = useCallback((groupIds: string[], groupsList: types.IGroupListAttributes[]) => {
    return groupIds
      .map(groupId => {
        const group = groupsList.find(group => group.id === groupId);
        return group ? { label: group.name, value: groupId } : null;
      })
      .filter(Boolean) as { label: string; value: string }[];
  }, []);

  const putShareProductGroup = useCallback(async (groupID: string, productID: string) => {
    setSetShareGroupStatus(false);
  
    const setProductShareResponse = await api.putShareProductGroup({
      id: productID,
      body: {
        id: groupID
      }
    });
  
    if (setProductShareResponse.result === variables.DEFAULT_API_RESULT.SUCCESS) {
      setSetShareGroupStatus(true);
      setShareGroupResponse('All good... your desktop had been shared');
      setLoading(false);
      setHasShared(true);
      callback();
      toast.success('Successfully Added Group');
    } else {
      setSetShareGroupStatus(true);
      callback();
      setShareGroupResponse('Oh ... something went wrong!');
      toast.warn('Sorry the group wasn\'t added, are you the owner?');
      setLoading(false);
    }
  }, [callback, setHasShared, setLoading, setSetShareGroupStatus, setShareGroupResponse]);
  

  const delShareProductGroup = useCallback(async (groupID: string, productID: string) => {
    setSetShareGroupStatus(false);
  
    const delProductShareResponse = await api.delShareProductGroup({
      id: productID,
      body: {
        id: groupID
      }
    });
  
    if (delProductShareResponse.result === variables.DEFAULT_API_RESULT.SUCCESS) {
      setSetShareGroupStatus(true);
      setShareGroupResponse('All good... Group has been removed from desktop sharing');
      setLoading(false);
      setHasShared(true);
      callback();
      toast.success('Successfully Removed Group');
    } else {
      setSetShareGroupStatus(true);
      callback();
      setShareGroupResponse('Oh ... something went wrong!');
      setLoading(false);
      toast.warn('Sorry the group wasn\'t removed, are you the owner?');
    }
  }, [callback, setHasShared, setLoading, setSetShareGroupStatus, setShareGroupResponse]);
  

  const valueRenderer = (selected: typeof options) => {

    if (!selected.length) {
      return <></>;
    }

    return selected.length === 1 ? (
      <span className='k-bg-selected m-1 p-1 b-rad-5'>{selected[0].label}</span>
    ) : (
      selected.map(({ label }) => <span className='k-bg-selected m-1 p-1 b-rad-5' key={label}>{label}</span>)
    );

    
  };

  const handleClose = useCallback(() => {
    setShow(false);
    setHasShared(false);
    // setSelected([]);
    // setOldSelected([]);
  }, [setShow, setHasShared]);  

  const handleClick = () => setLoading(true);

  const updateSharedGroups = useCallback(async () => {
    let groupsToAdd: typeof selected | null = null;
    let groupsToRemove: typeof selected | null = null;
  
    if (oldSelected.length > 0) {
      groupsToAdd = selected.filter(group => !oldSelected.some(old => old.value === group.value));
      groupsToRemove = oldSelected.filter(group => !selected.some(sel => sel.value === group.value));
    } else {
      groupsToAdd = selected;
    }
  
    if (groupsToAdd) {
      for (const group of groupsToAdd) {
        await putShareProductGroup(group.value, prodId);
      }
    }
  
    if (groupsToRemove) {
      for (const group of groupsToRemove) {
        await delShareProductGroup(group.value, prodId);
      }
    }
  
    setOldSelected(selected);
    handleClose();
  }, [selected, oldSelected, prodId, handleClose, delShareProductGroup, putShareProductGroup]);
  

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {

    if (status == true){
      setHasShared(false);
      // Call getGroups and wait for its completion using await
      const fetchData = async () => {
        const groupsList = await getGroups();

        
        // After getGroups has finished, update the selected state
        if(prodShare) {
          setSelected(mapGroupIdsToGroups(prodShare, groupsList));
          setOldSelected(mapGroupIdsToGroups(prodShare, groupsList));
        } else {
          setSelected([])
        }
      };

      fetchData();
    }
  }, [status]);
  /* eslint-enable react-hooks/exhaustive-deps */

  useEffect(() => {
    if (isLoading) {
      updateSharedGroups();
    }
  }, [isLoading, updateSharedGroups]);

  useEffect(() => {
    // Transform the group data into options for the dropdown
    const groupOptions = groupList && groupList.map((group) => ({
      label: group.name,
      value: group.id,
    }));

    setOptions(groupOptions);

  }, [groupList]);


  return (
    <Modal show={status} onHide={() => setShow(false)} centered className='k-z-ind-9999' dialogClassName="k-min-w-600">
      <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-mh-35 k-menu-grey-two-bg'>
        <Row className='mt-1 k-panel-cent-vert'>
          <Col className='col-10'>
            <Modal.Title as="h5" className='p-1'>{title}</Modal.Title>
          </Col>
          <Col className='col-2 k-center-content-hor-right'>
            <button className='custom-close-button k-pointer' onClick={() => setShow(false)} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
              <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
            </button>
          </Col>
        </Row>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <span className='txt-12 pt-2'>Select the groups from the dropdown box, and share your desktop!</span>
        </Row>
        <Row>
          <p className="mb-0 mt-2">
              
            <Row>
              <Col className='col-9'>
                <MultiSelect
                  options={options}
                  value={selected}
                  onChange={setSelected}
                  valueRenderer={valueRenderer}
                  hasSelectAll={false}
                  labelledBy="Select"
                />
              </Col>
              <Col className='col-3 d-flex justify-content-center align-items-center'>
                <Button className="k-min-w-103 p-2" variant="outline-dark" disabled={isLoading} onClick={!isLoading ? handleClick : undefined}>
                  {isLoading ? 'updating...' : 'update'}
                </Button>
              </Col>
            </Row>
            <Row>
              <span className='txt-12 pt-2'>{hasShared ? 'Updated!' : ' '}</span>
            </Row>

            {/*<Spinner animation="border" variant="secondary" />*/}
            
          </p>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export const CenterModalProdAddResult: React.FC<types.IModal> = ({ status, title, setShow }) => {
  return (
    <Modal show={status} onHide={() => setShow(false)} centered className='k-z-ind-9999'>
      <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg'>
        <Row className='mt-1 k-panel-cent-vert'>
          <Col className='col-10'>
            <Modal.Title as="h5" className='p-1'>{title}</Modal.Title>
          </Col>
          <Col className='col-2 k-center-content-hor-right'>
            <button className='custom-close-button k-pointer' onClick={() => setShow(false)} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
              <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
            </button>
          </Col>
        </Row>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col className='col-12'>
            <Row className='pt-2'><Col className='col-12'><span className='txt-14 pt-2'>Success! Your virtual machine is starting, it will appear on the desktop shortly. You can now close this window</span></Col></Row>
            {/*<Row className='pt-2'><Col className='col-12'><span className='txt-14 pt-2'>You can now close this window</span></Col></Row>*/}
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export const CenterModalProdTerminate: React.FC<types.IModal> = ({ status, title, setShow, prodId, callback, prodName }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const terminateProduct = async(productID: any) => {
    setIsLoading(true);
    callback(productID, 'terminate', 'Terminate', 'Product has been removed', 0); // Notify the parent

    // Simulate an async operation unitil we put proper feedback in from API
    setTimeout(() => {
      setShow(false)
      setIsLoading(false);
    }, 1000); // Adjust the delay as needed for your use case
  };


  return (
    <Modal show={status} onHide={() => setShow(false)} centered className='k-z-ind-9999'>
      <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg'>
        <Row className='mt-1 k-panel-cent-vert'>
          <Col className='col-10'>
            <Modal.Title as="h5" className='p-1'>{title}</Modal.Title>
          </Col>
          <Col className='col-2 k-center-content-hor-right'>
            <button className='custom-close-button k-pointer' onClick={() => setShow(false)} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
              <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
            </button>
          </Col>
        </Row>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col className='col-12'>
            <Row className='pt-2'>
              <Col className='col-8'>
                <span className='txt-14 pt-2'>Please confirm that you wish to remove <span className='txt-bold'>{prodName || 'this device'}</span>. Once confirmed cannot be undone</span>
              </Col>
              <Col className='col-4 k-center-content'>
                {isLoading ? (
                  <div className='k-mh-25 k-center-content-hor-right k-center-content'>
                    <Spinner animation="border" role="status" >
                      <span className="visually-hidden">Removing...</span>
                    </Spinner>
                  </div>
                ) : (
                  <div  className='k-center-content-hor-right k-center-content'>
                    <Button className='k-mh-45' variant="light" onClick={() => {terminateProduct(prodId)}}>Confirm</Button>
                  </div>
                )}
              </Col>
            </Row>
            {/*<Row className='pt-2'><Col className='col-12'><span className='txt-14 pt-2'>You can now close this window</span></Col></Row>*/}
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export const ProductTerminate: React.FC<types.IGenericPromptModal> = ({ isVisible, content, handleModalHide, handleModalPromptConfirm }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleTerminateConfirm = async () => {
    setIsLoading(true);
    // callback(productID, 'terminate', 'Terminate', 'Product has been removed', 0); // Notify the parent// confirm
    await handleModalPromptConfirm();

    // Simulate an async operation unitil we put proper feedback in from API
    setTimeout(() => {
      setIsLoading(false); // Disable loading
      handleModalHide(); // Hide modal 
    }, 1000); // Adjust the delay as needed for your use case
  };


  return (
    <Modal show={isVisible} onHide={handleModalHide} centered className='k-z-ind-9999'>
      <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg'>
        <Row className='mt-1 k-panel-cent-vert'>
          <Col className='col-10'>
            <Modal.Title as="h5" className='p-1'>Confirm Termination</Modal.Title>
          </Col>
          <Col className='col-2 k-center-content-hor-right'>
            <button className='custom-close-button k-pointer' onClick={handleModalHide} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
              <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
            </button>
          </Col>
        </Row>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col className='col-12'>
            <Row className='pt-2'>
              <Col className='col-8'>
                <span className='txt-14 pt-2'>Please confirm that you wish to remove <span className='txt-bold'>{content.product.name || 'this device'}</span>. Once confirmed cannot be undone</span>
              </Col>
              <Col className='col-4 k-center-content'>
                {isLoading ? (
                  <div className='k-mh-25 k-center-content-hor-right k-center-content'>
                    <Spinner animation="border" role="status" >
                      <span className="visually-hidden">{content.loadingMessage || 'Removing...'}</span>
                    </Spinner>
                  </div>
                ) : (
                  handleTerminateConfirm && <div  className='k-center-content-hor-right k-center-content'>
                    <Button className='k-mh-45' variant="light" onClick={handleTerminateConfirm}>Confirm</Button>
                  </div>
                )}
              </Col>
            </Row>
            {/*<Row className='pt-2'><Col className='col-12'><span className='txt-14 pt-2'>You can now close this window</span></Col></Row>*/}
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export const ProductPresignedLink: React.FC<types.IGenericPromptModal> = ({ isVisible, content, handleModalHide }) => {
  const [_linkCopied, setLinkCopied] = useState<boolean>(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(content.product.shareUrl);
    setLinkCopied(true);    
  };
  
  //Run on load
  useEffect(() => {
    if (isVisible){
      setLinkCopied(false);
    }
  }, [isVisible]);

  

  return (
    <Modal show={isVisible} onHide={handleModalHide} centered className='k-z-ind-9999'>
      <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg'>
        <Row className='mt-1 k-panel-cent-vert'>
          <Col className='col-10'>
            <Modal.Title as="h5" className='p-1'>{content.title}</Modal.Title>
          </Col>
          <Col className='col-2 k-center-content-hor-right'>
            <button className='custom-close-button k-pointer' onClick={handleModalHide} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
              <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
            </button>
          </Col>
        </Row>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <span className='txt-12 pt-2'>Generate your personalised link below to easily share with others. Simply copy and send it to allow them direct access to your virtual machine!</span>
        </Row>
        <Row>
          <p className="mb-0 mt-4">
            { content.product.isRunning ?
              <>
                {content.product.shareUrl ? 
                  <Row>
                    <Col className='col-10'>
                      <span className='k-clip-text txt-12 pt-2 color-RS'>{content.product.shareUrl}</span>
                    </Col>
                    <Col className='col-2'>
                      <button className='k-click' onClick={copyToClipboard} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
                        <BiCopy />
                      </button>
                    </Col>
                  </Row>
                  :
                  <Spinner animation="border" variant="secondary" />
                }
              </>
              :
              <>
                <Row>
                  <Col className='col-12'>
                    <span className='k-clip-text txt-12 pt-1 color-RS'>Sorry! Your desktop needs to be running to generate a share link!</span>
                  </Col>
                </Row>
              </>
            }
            {
              /*linkCopied ? 
                  <Row><Col><span className='color-lightText'>copied!</span></Col></Row> 
                  : 
                  <Row><Col><span className='color-transparent'>_</span></Col></Row> 
                */
            }
          </p>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export const ConfirmReleaseModal: React.FC<types.ConfirmReleaseModalProps> = ({ show, number, onClose, onConfirm }) => {
  const [inputValue, setInputValue] = React.useState('');

  const handleConfirm = () => {
    onConfirm(inputValue);
    setInputValue(''); // Reset input value on confirm
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header className='p-0 ps-3 pe-3 k-display-block k-menu-grey-two-bg'>
        <Row className='mt-1 k-panel-cent-vert'>
          <Col className='col-10'>
            <Modal.Title as="h5" className='p-1'>Confirm Release</Modal.Title>
          </Col>
          <Col className='col-2 k-center-content-hor-right'>
            <button className='custom-close-button k-pointer' onClick={onClose} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
              <img className='k-mh-20 k-opac-50pc k-pointer k-mb-02r' src={closeBtn}></img>
            </button>
          </Col>
        </Row>
      </Modal.Header>
      <Modal.Body className='pt-1'>
        <p>
          To confirm the release of <strong>{number}</strong> please type the number below. Once a number has been released it will be made available for the general public.
        </p>
        <Form>
          <Form.Group controlId="confirmationInput">
            <Form.Label>Enter Number</Form.Label>
            <Row>
              <Col className='col-9'>
                <Form.Control
                  type="text"
                  placeholder="Enter the number to confirm"
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                />
              </Col>
              <Col className='col-3'>
                <Button className='k-mh-45' variant="light" onClick={handleConfirm}>
                  Confirm
                </Button>
              </Col>
            </Row>
          </Form.Group>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
